import { v3 as s, m4 as M } from "twgl.js";
var zt, kt, $, Z, yt, St, Et, It;
(function(r) {
  r.create = function(t, n) {
    const o = new Float32Array(2);
    return t && (o[0] = t), n && (o[1] = n), o;
  }, r.zero = function() {
    return [0, 0];
  }, r.add = function(t, n, o) {
    return (o = o || new Float32Array(2))[0] = t[0] + n[0], o[1] = t[1] + n[1], o;
  }, r.subtract = function(t, n, o) {
    return (o = o || new Float32Array(2))[0] = t[0] - n[0], o[1] = t[1] - n[1], o;
  }, r.lerp = function(t, n, o, i) {
    return (i = i || new Float32Array(2))[0] = (1 - o) * t[0] + o * n[0], i[1] = (1 - o) * t[1] + o * n[1], i;
  }, r.mulScalar = function(t, n, o) {
    return (o = o || new Float32Array(2))[0] = t[0] * n, o[1] = t[1] * n, o;
  }, r.divScalar = function(t, n, o) {
    return (o = o || new Float32Array(2))[0] = t[0] / n, o[1] = t[1] / n, o;
  }, r.dot = function(t, n) {
    return t[0] * n[0] + t[1] * n[1];
  }, r.length = function(t) {
    return Math.sqrt(t[0] * t[0] + t[1] * t[1]);
  }, r.lengthSq = function(t) {
    return t[0] * t[0] + t[1] * t[1];
  }, r.distance = function(t, n) {
    const o = t[0] - n[0], i = t[1] - n[1];
    return Math.sqrt(o * o + i * i);
  }, r.distanceSq = function(t, n) {
    const o = t[0] - n[0], i = t[1] - n[1];
    return o * o + i * i;
  }, r.normalize = function(t, n) {
    n = n || new Float32Array(2);
    const o = t[0] * t[0] + t[1] * t[1], i = Math.sqrt(o);
    return i > 1e-5 ? (n[0] = t[0] / i, n[1] = t[1] / i) : (n[0] = 0, n[1] = 0), n;
  }, r.negate = function(t, n) {
    return (n = n || new Float32Array(2))[0] = -t[0], n[1] = -t[1], n;
  }, r.copy = function(t, n) {
    return (n = n || new Float32Array(2))[0] = t[0], n[1] = t[1], n;
  }, r.multiply = function(t, n, o) {
    return (o = o || new Float32Array(2))[0] = t[0] * n[0], o[1] = t[1] * n[1], o;
  }, r.divide = function(t, n, o) {
    return (o = o || new Float32Array(2))[0] = t[0] / n[0], o[1] = t[1] / n[1], o;
  };
})(zt || (zt = {}));
Math.accelerate = function(r, t = 1.5) {
  return Math.abs(r) ** t * (r > 0 ? 1 : -1);
}, Math.clamp = (r, t, n) => Math.max(Math.min(r, n), t), Math.isPowerOf2 = (r) => !(r & r - 1), Math.lerp = (r, t, n) => (1 - n) * r + n * t, Math.modulo = (r, t) => {
  const n = r - Math.trunc(r / t) * t;
  return n > 0 ? n : n + t;
}, Math.nearestLowerPowerOf2 = (r) => 1 << 31 - Math.clz32(r), Math.degreesToRadians = (r) => r * Math.PI / 180, Math.radiansToDegrees = (r) => 180 * r / Math.PI, Math.sRGBToLinear = (r) => r <= 0.04045 ? r / 12.92 : Math.pow((r + 0.055) / 1.055, 2.4), Math.toHalf = function() {
  const r = new Float32Array(1), t = new Int32Array(r.buffer);
  return function(n) {
    r[0] = n;
    const o = t[0], i = o >> 16 & 32768;
    let e = 4096 + (2147483647 & o);
    return e >= 1199570944 ? (2147483647 & o) >= 1199570944 ? e < 2139095040 ? 31744 | i : 31744 | i | (8388607 & o) >> 13 : 31743 | i : e >= 947912704 ? i | e - 939524096 >> 13 : e < 855638016 ? i : (e = (2147483647 & o) >> 23, i | (8388607 & o | 8388608) + (8388608 >>> e - 102) >> 126 - e);
  };
}(), Math.fromHalf = function() {
  function r() {
    const i = new Float32Array(1);
    return { u: new Uint32Array(i.buffer), f: i };
  }
  const t = 260046848, n = r();
  n.u[0] = 113 << 23;
  const o = r();
  return function(i) {
    o.u[0] = (32767 & i) << 13;
    const e = t & o.u[0];
    return o.u[0] += 112 << 23, e === t ? o.u[0] += 112 << 23 : e == 0 && (o.u[0] += 1 << 23, o.f[0] -= n.f[0]), o.u[0] |= (32768 & i) << 16, o.f[0];
  };
}();
(function(r) {
  r.left = "left", r.right = "right";
})(kt || (kt = {}));
(function(r) {
  r[r.one = 1] = "one", r[r.two = 2] = "two", r[r.three = 3] = "three", r[r.four = 4] = "four";
})($ || ($ = {})), function(r) {
  r.from = function(t) {
    switch (t) {
      case "1":
        return r.one;
      case "2":
        return r.two;
      case "3":
        return r.three;
      case "4":
        return r.four;
      default:
        throw new Error("Unknown data layout component");
    }
  };
}($ || ($ = {})), function(r) {
  r.uchar = "uchar", r.char = "char", r.ushort = "ushort", r.short = "short", r.uint = "uint", r.int = "int", r.half = "half", r.float = "float";
}(Z || (Z = {})), function(r) {
  r.from = function(t) {
    switch (t) {
      case "uchar":
        return r.uchar;
      case "char":
        return r.char;
      case "ushort":
        return r.ushort;
      case "short":
        return r.short;
      case "uint":
        return r.uint;
      case "int":
        return r.int;
      case "half":
        return r.half;
      case "float":
        return r.float;
      default:
        throw new Error("Unknown data layout type");
    }
  }, r.typedArray = function(t) {
    switch (t) {
      case r.uchar:
        return Uint8Array;
      case r.char:
        return Int8Array;
      case r.ushort:
        return Uint16Array;
      case r.short:
        return Int16Array;
      case r.uint:
        return Uint32Array;
      case r.int:
        return Int32Array;
      case r.half:
        return Uint16Array;
      case r.float:
        return Float32Array;
      default:
        throw new Error("Unknown data layout type");
    }
  };
}(Z || (Z = {}));
(function(r) {
  r.frustumBased = "frustumBased", r.fixedDepthRange = "fixedDepthRange", r.lookAtPointBasedInterest = "lookAtPointBasedInterest", r.useGlobalPolicy = "useGlobalPolicy";
})(yt || (yt = {}));
(function(r) {
  r.x = "x", r.y = "y";
})(St || (St = {}));
(function(r) {
  r.landscape = "landscape", r.portrait = "portrait";
})(Et || (Et = {}));
(function(r) {
  r.never = "never", r.always = "always", r.surface = "surface";
})(It || (It = {}));
var Bt, K, Ot, Ft, A, T, ht, Gt, qt, Ht, Vt, Ut, Kt, wt, Yt, jt, Wt, Xt, Qt, $t, Zt, At, Jt;
(function(r) {
  r.none = "none", r.aabb = "aabb", r.hemisphere = "hemisphere", r.mesh = "mesh";
})(Bt || (Bt = {}));
(function(r) {
  r.x = "x", r.y = "y", r.z = "z";
})(K || (K = {}));
(function(r) {
  r[r.none = 0] = "none", r[r.rotation = 1] = "rotation", r[r.translation = 2] = "translation", r[r.all = 3] = "all";
})(Ot || (Ot = {})), function(r) {
  r.identity = function(t) {
    return (t = t || new Float32Array(9))[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 1, t[5] = 0, t[6] = 0, t[7] = 0, t[8] = 1, t;
  }, r.multiply = function(t, n, o) {
    o = o || new Float32Array(9);
    const i = t[0], e = t[1], a = t[2], c = t[3], p = t[4], f = t[5], R = t[6], L = t[7], u = t[8], m = n[0], b = n[1], l = n[2], F = n[3], S = n[4], O = n[5], h = n[6], B = n[7], w = n[8];
    return o[0] = i * m + c * b + R * l, o[1] = e * m + p * b + L * l, o[2] = a * m + f * b + u * l, o[3] = i * F + c * S + R * O, o[4] = e * F + p * S + L * O, o[5] = a * F + f * S + u * O, o[6] = i * h + c * B + R * w, o[7] = e * h + p * B + L * w, o[8] = a * h + f * B + u * w, o;
  }, r.transformPoint = function(t, n, o) {
    o = o || s.create();
    const i = n[0], e = n[1], a = n[2];
    return o[0] = i * t[0] + e * t[3] + a * t[6], o[1] = i * t[1] + e * t[4] + a * t[7], o[2] = i * t[2] + e * t[5] + a * t[8], o;
  }, r.m4 = function(t, n) {
    return (n = n || new Float32Array(16))[0] = t[0], n[1] = t[1], n[2] = t[2], n[3] = 0, n[4] = t[3], n[5] = t[4], n[6] = t[5], n[7] = 0, n[8] = t[6], n[9] = t[7], n[10] = t[8], n[11] = 0, n[12] = 0, n[13] = 0, n[14] = 0, n[15] = 1, n;
  };
}(Ft || (Ft = {})), function(r) {
  r.create = function(t, n, o, i) {
    const e = new Float32Array(4);
    return t && (e[0] = t), n && (e[1] = n), o && (e[2] = o), i && (e[3] = i), e;
  }, r.add = function(t, n, o) {
    return (o = o || new Float32Array(4))[0] = t[0] + n[0], o[1] = t[1] + n[1], o[2] = t[2] + n[2], o[3] = t[3] + n[3], o;
  }, r.subtract = function(t, n, o) {
    return (o = o || new Float32Array(4))[0] = t[0] - n[0], o[1] = t[1] - n[1], o[2] = t[2] - n[2], o[3] = t[3] - n[3], o;
  }, r.lerp = function(t, n, o, i) {
    return (i = i || new Float32Array(4))[0] = (1 - o) * t[0] + o * n[0], i[1] = (1 - o) * t[1] + o * n[1], i[2] = (1 - o) * t[2] + o * n[2], i[3] = (1 - o) * t[3] + o * n[3], i;
  }, r.slerp = function(t, n, o, i) {
    const e = r.normalize(t);
    let a = r.normalize(n), c = r.dot(e, a);
    if (c < 0 && (a = r.negate(a), c = -c), c > 0.9995) {
      const b = r.add(e, r.mulScalar(r.subtract(a, e), o));
      return r.normalize(b, b), b;
    }
    const p = Math.acos(c), f = p * o, R = Math.sin(f), L = Math.sin(p), u = Math.cos(f) - c * R / L, m = R / L;
    return r.add(r.mulScalar(e, u), r.mulScalar(a, m));
  }, r.mulScalar = function(t, n, o) {
    return (o = o || new Float32Array(4))[0] = t[0] * n, o[1] = t[1] * n, o[2] = t[2] * n, o[3] = t[3] * n, o;
  }, r.divScalar = function(t, n, o) {
    return (o = o || new Float32Array(4))[0] = t[0] / n, o[1] = t[1] / n, o[2] = t[2] / n, o[3] = t[3] / n, o;
  }, r.dot = function(t, n) {
    return t[0] * n[0] + t[1] * n[1] + t[2] * n[2] + t[3] * n[3];
  }, r.length = function(t) {
    return Math.sqrt(t[0] * t[0] + t[1] * t[1] + t[2] * t[2] + t[2] * t[2] + t[3] * t[3]);
  }, r.lengthSq = function(t) {
    return t[0] * t[0] + t[1] * t[1] + t[2] * t[2] + t[3] * t[3];
  }, r.distance = function(t, n) {
    const o = t[0] - n[0], i = t[1] - n[1], e = t[2] - n[2], a = t[3] - n[3];
    return Math.sqrt(o * o + i * i + e * e + a * a);
  }, r.distanceSq = function(t, n) {
    const o = t[0] - n[0], i = t[1] - n[1], e = t[2] - n[2], a = t[3] - n[3];
    return o * o + i * i + e * e + a * a;
  }, r.normalize = function(t, n) {
    n = n || new Float32Array(4);
    const o = t[0] * t[0] + t[1] * t[1] + t[2] * t[2] + t[3] * t[3], i = Math.sqrt(o);
    return i > 1e-5 ? (n[0] = t[0] / i, n[1] = t[1] / i, n[2] = t[2] / i, n[3] = t[3] / i) : (n[0] = 0, n[1] = 0, n[2] = 0, n[3] = 0), n;
  }, r.negate = function(t, n) {
    return (n = n || new Float32Array(4))[0] = -t[0], n[1] = -t[1], n[2] = -t[2], n[3] = -t[3], n;
  }, r.copy = function(t, n) {
    return (n = n || new Float32Array(4))[0] = t[0], n[1] = t[1], n[2] = t[2], n[3] = t[3], n;
  }, r.multiply = function(t, n, o) {
    return (o = o || new Float32Array(4))[0] = t[0] * n[0], o[1] = t[1] * n[1], o[2] = t[2] * n[2], o[3] = t[3] * n[3], o;
  }, r.divide = function(t, n, o) {
    return (o = o || new Float32Array(4))[0] = t[0] / n[0], o[1] = t[1] / n[1], o[2] = t[2] / n[2], o[3] = t[3] / n[3], o;
  }, r.Zero = [0, 0, 0, 0], r.One = [1, 1, 1, 1];
}(A || (A = {})), function(r) {
  function t(a, c, p, f, R, L, u) {
    const m = c + a, b = c - a, l = f + p, F = f - p, S = L - R;
    return (u = u || new Float32Array(16))[0] = 2 * R / b, u[1] = 0, u[2] = 0, u[3] = 0, u[4] = 0, u[5] = 2 * R / F, u[6] = 0, u[7] = 0, u[8] = m / b, u[9] = l / F, u[10] = -L / S, u[11] = -1, u[12] = 0, u[13] = 0, u[14] = -L * R / S, u[15] = 0, u;
  }
  function n(a, c) {
    c = c || s.create();
    const p = [a[0], a[4], a[8]], f = [a[1], a[5], a[9]], R = [a[2], a[6], a[10]], L = a[15];
    return c[0] = s.length(p) / L, c[1] = s.length(f) / L, c[2] = s.length(R) / L, s.dot(s.cross(p, f), R) < 0 && (c[2] = -c[2]), c;
  }
  function o(a, c) {
    c = c || new Float32Array(16);
    const p = n(a);
    return c[0] = a[0] * (p[0] === 0 ? 1 : 1 / p[0]), c[1] = a[1] * (p[1] === 0 ? 1 : 1 / p[1]), c[2] = a[2] * (p[2] === 0 ? 1 : 1 / p[2]), c[3] = a[3], c[4] = a[4] * (p[0] === 0 ? 1 : 1 / p[0]), c[5] = a[5] * (p[1] === 0 ? 1 : 1 / p[1]), c[6] = a[6] * (p[2] === 0 ? 1 : 1 / p[2]), c[7] = a[7], c[8] = a[8] * (p[0] === 0 ? 1 : 1 / p[0]), c[9] = a[9] * (p[1] === 0 ? 1 : 1 / p[1]), c[10] = a[10] * (p[2] === 0 ? 1 : 1 / p[2]), c[11] = a[11], c[12] = a[12] * (p[0] === 0 ? 1 : 1 / p[0]), c[13] = a[13] * (p[1] === 0 ? 1 : 1 / p[1]), c[14] = a[14] * (p[2] === 0 ? 1 : 1 / p[2]), c[15] = a[15], c;
  }
  function i(a, c) {
    return (c = c || new Float32Array(3))[0] = Math.sRGBToLinear(a[0]), c[1] = Math.sRGBToLinear(a[1]), c[2] = Math.sRGBToLinear(a[2]), c;
  }
  function e(a, c) {
    c = c || new Float32Array(3);
    const p = [].concat.apply([], [[0.529345989, 0.0983742997, 0.0168831889], [0.33007285, 0.873461008, 0.117672503], [0.14058122, 0.0281646773, 0.865444302]]);
    return Ft.transformPoint(p, a, c);
  }
  r.lookAtConstraint = function(a, c, p, f) {
    f = f || new Float32Array(16);
    const R = s.normalize(a);
    let L = s.cross([0, 1, 0], R);
    L = s.dot(L, L) < 1e-5 ? [1, 0, 0] : s.normalize(L);
    const u = s.cross(R, L);
    let m, b, l;
    switch (c) {
      case K.x:
        m = R, p === K.y ? (b = u, l = s.cross(m, b)) : (l = u, b = s.cross(l, m));
        break;
      case K.y:
        b = R, p === K.x ? (m = u, l = s.cross(m, b)) : (l = u, m = s.cross(b, l));
        break;
      case K.z:
        l = R, p === K.x ? (m = u, b = s.cross(l, m)) : (b = u, m = s.cross(b, l));
        break;
      default:
        throw new Error(`Unknown HSKinematicsConstraintAxis: ${c}`);
    }
    return f[0] = m[0], f[1] = m[1], f[2] = m[2], f[3] = 0, f[4] = b[0], f[5] = b[1], f[6] = b[2], f[7] = 0, f[8] = l[0], f[9] = l[1], f[10] = l[2], f[11] = 0, f[12] = 0, f[13] = 0, f[14] = 0, f[15] = 1, f;
  }, r.ortho = function(a, c, p, f, R, L, u) {
    const m = c + a, b = c - a, l = f + p, F = f - p, S = L - R;
    return (u = u || new Float32Array(16))[0] = 2 / b, u[1] = 0, u[2] = 0, u[3] = 0, u[4] = 0, u[5] = 2 / F, u[6] = 0, u[7] = 0, u[8] = 0, u[9] = 0, u[10] = -1 / S, u[11] = 0, u[12] = -m / b, u[13] = -l / F, u[14] = -R / S, u[15] = 1, u;
  }, r.perspectiveWithFovY = function(a, c, p, f, R) {
    const L = p * Math.tan(a / 2), u = L * c;
    return t(-u, u, -L, L, p, f, R);
  }, r.perspectiveWithLeft = t, r.quaternion = function(a, c) {
    c = c || new Float32Array(16);
    const p = 2 / A.dot(a, a), f = a[0] * p, R = a[1] * p, L = a[2] * p, u = a[3] * f, m = a[3] * R, b = a[3] * L, l = a[0] * f, F = a[0] * R, S = a[0] * L, O = a[1] * R, h = a[1] * L, B = a[2] * L;
    return c[0] = 1 - (O + B), c[1] = F + b, c[2] = S - m, c[3] = 0, c[4] = F - b, c[5] = 1 - (l + B), c[6] = h + u, c[7] = 0, c[8] = S + m, c[9] = h - u, c[10] = 1 - (l + O), c[11] = 0, c[12] = 0, c[13] = 0, c[14] = 0, c[15] = 1, c;
  }, r.eulerOrientation = function(a) {
    const c = Math.atan2(a[6], a[10]), p = Math.sqrt(a[0] * a[0] + a[1] * a[1]), f = Math.atan2(-a[2], p), R = Math.sin(c), L = Math.cos(c);
    return [c, f, Math.atan2(R * a[8] - L * a[4], L * a[5] - R * a[9])];
  }, r.rotationEuler = function(a, c) {
    c = c || new Float32Array(16);
    const p = Math.cos(a[0]), f = Math.sin(a[0]), R = Math.cos(a[1]), L = Math.sin(a[1]), u = Math.cos(a[2]), m = Math.sin(a[2]);
    return c[0] = R * u, c[1] = R * m, c[2] = -L, c[3] = 0, c[4] = f * L * u - p * m, c[5] = f * L * m + p * u, c[6] = f * R, c[7] = 0, c[8] = p * L * u + f * m, c[9] = p * L * m - f * u, c[10] = p * R, c[11] = 0, c[12] = 0, c[13] = 0, c[14] = 0, c[15] = 1, c;
  }, r.setRotation = function(a, c, p) {
    return (p = p || M.identity())[0] = c[0], p[1] = c[1], p[2] = c[2], p[3] = c[3], p[4] = c[4], p[5] = c[5], p[6] = c[6], p[7] = c[7], p[8] = c[8], p[9] = c[9], p[10] = c[10], p[11] = c[11], p[12] = a[12], p[13] = a[13], p[14] = a[14], p[15] = a[15], p;
  }, r.getScaling = n, r.withoutScaling = o, r.bumpTBNMatrix = function(a, c) {
    return c = c || M.identity(), M.setTranslation(a, [0, 0, 0], c), o(c, c), M.transpose(c, c), c;
  }, r.normalMatrix = function(a, c) {
    return c = c || M.identity(), M.inverse(a, c), M.transpose(c, c), c;
  }, r.transformPoint = function(a, c, p) {
    p = p || A.create();
    const f = c[0], R = c[1], L = c[2];
    return c[3], p[0] = f * a[0] + R * a[4] + L * a[8] + a[12], p[1] = f * a[1] + R * a[5] + L * a[9] + a[13], p[2] = f * a[2] + R * a[6] + L * a[10] + a[14], p[3] = f * a[3] + R * a[7] + L * a[11] + a[15], p;
  }, r.zero = function() {
    return [0, 0, 0];
  }, r.one = function() {
    return [1, 1, 1];
  }, r.xAxis = function() {
    return [1, 0, 0];
  }, r.yAxis = function() {
    return [0, 1, 0];
  }, r.zAxis = function() {
    return [0, 0, 1];
  }, r.gamma = function(a, c, p) {
    return (p = p || new Float32Array(3))[0] = a[0] ** c, p[1] = a[1] ** c, p[2] = a[2] ** c, p;
  }, r.squared = function(a) {
    return s.dot(a, a);
  }, r.sRGBToRGB = i, r.rgbToLCS = e, r.sRGBToLCS = function(a, c) {
    return e(i(a, c), c);
  };
}(T || (T = {}));
(function(r) {
  r.black = "black", r.background = "background", r.environment = "environment";
})(ht || (ht = {}));
(function(r) {
  r.mix = "mix", r.mul = "mul", r.add = "add";
})(Gt || (Gt = {})), function(r) {
  r.diffuse = "diffuse", r.diffuseSpecular = "diffuseSpecular", r.transparent = "transparent";
}(qt || (qt = {}));
(function(r) {
  r.left = "left", r.middle = "middle", r.right = "right";
})(Ht || (Ht = {})), function(r) {
  r.texture = "texture", r.screen = "screen", r.userDefined = "userDefined";
}(Vt || (Vt = {})), function(r) {
  r.sticker = "sticker", r.sprite = "sprite";
}(Ut || (Ut = {})), function(r) {
  r.top = "top", r.middle = "middle", r.bottom = "bottom";
}(Kt || (Kt = {}));
(function(r) {
  r.none = "none", r.gradient = "gradient", r.environment = "environment";
})(wt || (wt = {}));
(function(r) {
  r.none = "none", r.rotateY = "rotateY", r.rotateXy = "rotateXy";
})(Yt || (Yt = {}));
(function(r) {
  r.followBezierPath = "followBezierPath", r.followBezierPathPosition = "followBezierPathPosition", r.fixedDirection = "fixedDirection", r.fixedPosition = "fixedPosition", r.followNull = "followNull";
})(jt || (jt = {})), function(r) {
  r.followBezierPath = "followBezierPath", r.fixed = "fixed", r.followNull = "followNull";
}(Wt || (Wt = {}));
(function(r) {
  r.linear = "linear", r.jump = "jump", r.orbit = "orbit", r.head = "head", r.spline = "spline", r.quadIn = "quadIn", r.quadOut = "quadOut", r.quadInOut = "quadInOut";
})(Xt || (Xt = {}));
(function(r) {
  r.bezier = "bezier", r.linear = "linear", r.step = "step";
})(Qt || (Qt = {}));
(function(r) {
  r.linear = "linear", r.inQuad = "inQuad", r.outQuad = "outQuad", r.inOutQuad = "inOutQuad";
})($t || ($t = {}));
(function(r) {
  r.continued = "continued", r.reset = "reset", r.invertWithPause = "invertWithPause", r.invertWithoutPause = "invertWithoutPause";
})(Zt || (Zt = {}));
(function(r) {
  r.none = "none", r.repeated = "repeated", r.incremented = "incremented";
})(At || (At = {})), function(r) {
  r.product = "product", r.configuration = "configuration", r.camera = "camera", r.channels = "channels", r.video = "video";
}(Jt || (Jt = {}));
var Dt, I, _t;
(function(r) {
  r[r.outside = 1] = "outside", r[r.inside = -1] = "inside", r[r.over = -2] = "over";
})(Dt || (Dt = {}));
(function(r) {
  r.back = "back", r.front = "front", r.cross = "cross";
})(I || (I = {}));
class H {
  constructor() {
    this.pointMin = T.zero(), this.pointMax = T.zero(), this.isInitialized = !1;
  }
  static initPoint(t) {
    const n = new H();
    return n.pointMin = s.copy(t), n.pointMax = s.copy(t), n.isInitialized = !0, n;
  }
  static initCenter(t, n) {
    const o = new H();
    return o.pointMin = s.mulScalar(s.subtract(t, n), 0.5), o.pointMax = s.mulScalar(s.add(t, n), 0.5), o.isInitialized = !0, o;
  }
  static initPoints(t, n) {
    const o = new H();
    return o.pointMin = s.copy(t), o.pointMax = s.copy(n), o.isInitialized = !0, o;
  }
  extendsPoint(t) {
    if (!this.isInitialized) return H.initPoint(t);
    const n = this.pointMin.slice(), o = this.pointMax.slice();
    for (let i = 0, e = 3; i < e; i += 1) t[i] < n[i] ? n[i] = t[i] : t[i] > o[i] && (o[i] = t[i]);
    return H.initPoints(n, o);
  }
  extendsPoints(t) {
    let n = this;
    for (let o = 0, i = t.length; o < i; o += 1) n = n.extendsPoint(t[o]);
    return n;
  }
  extendsAabb(t) {
    let n = this;
    return t.isInitialized && (n = n.extendsPoint(t.pointMin).extendsPoint(t.pointMax)), n;
  }
  multiply(t) {
    const n = this.points.map((o) => M.transformPoint(t, o));
    return new H().extendsPoints(n);
  }
  get center() {
    if (!this.isInitialized) throw new Error("Aabb3 is not initialized");
    return s.mulScalar(s.add(this.pointMin, this.pointMax), 0.5);
  }
  get dimension() {
    if (!this.isInitialized) throw new Error("Aabb3 is not initialized");
    return s.subtract(this.pointMax, this.pointMin);
  }
  get matrix() {
    const t = M.translation(this.center), n = M.scaling(this.dimension);
    return M.multiply(t, n);
  }
  get points() {
    return [[this.pointMin[0], this.pointMin[1], this.pointMin[2]], [this.pointMin[0], this.pointMin[1], this.pointMax[2]], [this.pointMin[0], this.pointMax[1], this.pointMin[2]], [this.pointMin[0], this.pointMax[1], this.pointMax[2]], [this.pointMax[0], this.pointMin[1], this.pointMin[2]], [this.pointMax[0], this.pointMin[1], this.pointMax[2]], [this.pointMax[0], this.pointMax[1], this.pointMin[2]], [this.pointMax[0], this.pointMax[1], this.pointMax[2]]];
  }
  position(t) {
    if (!this.isInitialized) throw new Error("Aabb3 is not initialized");
    const n = T.zero(), o = T.zero();
    for (let e = 0, a = 3; e < a; e += 1) t.normal[e] >= 0 ? (n[e] = this.pointMin[e], o[e] = this.pointMax[e]) : (n[e] = this.pointMax[e], o[e] = this.pointMin[e]);
    let i = s.dot(t.normal, n) + t.q;
    return i > 0 ? I.front : (i = s.dot(t.normal, o) + t.q, i >= 0 ? I.cross : I.back);
  }
  projection(t) {
    const n = this.points, o = s.dot(s.subtract(n[0], t.origin), t.direction);
    let i = o, e = o;
    for (let a = 1; a < 8; a += 1) {
      const c = s.dot(s.subtract(n[a], t.origin), t.direction);
      c < i ? i = c : c > e && (e = c);
    }
    return { tMin: i, tMax: e };
  }
}
(function(r) {
  r.never = "never", r.always = "always", r.surface = "surface";
})(_t || (_t = {}));
class lo {
  constructor(t, n, o, i, e, a, c) {
    this.perspective = t, this.left = n, this.right = o, this.bottom = i, this.top = e, this.near = a, this.far = c;
  }
  get perspectiveMatrix() {
    return T.perspectiveWithLeft(this.left, this.right, this.bottom, this.top, this.near, this.far);
  }
  get orthoMatrix() {
    return M.ortho(this.left, this.right, this.bottom, this.top, this.near, this.far);
  }
  get projectionMatrix() {
    return this.perspective ? this.perspectiveMatrix : this.orthoMatrix;
  }
}
var J, dt;
(function(r) {
  r.nop = "nop", r.zoom = "zoom", r.pan = "pan", r.orbit = "orbit", r.roll = "roll", r.head = "head", r.fov = "fov", r.perspective = "perspective";
})(J || (J = {})), function(r) {
  r.isCamera = function(t) {
    return t === r.fov || t === r.perspective;
  };
}(J || (J = {}));
class j {
  constructor(t, n, o) {
    this.target = s.copy(t), this.eye = s.copy(n), this.up = s.copy(o);
  }
  get viewVector() {
    return s.subtract(this.target, this.eye);
  }
  get rightVector() {
    return s.normalize(s.cross(this.viewVector, this.up));
  }
  get viewMatrix() {
    return M.inverse(M.lookAt(this.eye, this.target, this.up));
  }
  clone() {
    return new j(s.copy(this.target), s.copy(this.eye), s.copy(this.up));
  }
  pick(t) {
    let n = T.yAxis();
    const o = s.normalize(s.subtract(t, this.eye)), i = s.dot(o, T.yAxis());
    if (1 - Math.abs(i) < 5e-3) {
      const e = s.normalize(s.subtract(this.target, this.eye)), a = s.normalize(s.cross(e, this.up)), c = Math.acos(s.dot(e, o)), p = M.axisRotation(a, c);
      n = M.multiply(p, this.up);
    }
    return new j(t, this.eye, n);
  }
  transform(t) {
    const n = M.transformPoint(t, this.target), o = M.transformPoint(t, this.eye), i = M.transformDirection(T.normalMatrix(t), this.up);
    return new j(n, o, i);
  }
}
j.default = new j([0, 0, 0], [2, 2, 2], [0, 1, 0]);
(function(r) {
  r.none = "none", r.standard = "standard", r.filtered = "filtered";
})(dt || (dt = {}));
var Y;
(function(r) {
  r[r.none = 0] = "none", r[r.top = 1] = "top", r[r.bottom = 2] = "bottom", r[r.left = 4] = "left", r[r.right = 8] = "right", r[r.zero = 16] = "zero", r[r.near = 32] = "near", r[r.far = 64] = "far";
})(Y || (Y = {}));
class E {
  constructor(t, n) {
    this.normal = t ? s.normalize(t) : T.zero(), this.q = n ? -s.dot(this.normal, n) : 0;
  }
  position(t) {
    const n = s.dot(this.normal, t) + this.q;
    return n === 0 ? I.cross : n > 0 ? I.front : I.back;
  }
  intersection(t) {
    const n = s.dot(this.normal, t.direction);
    if (n === 0) return;
    const o = -(s.dot(t.origin, this.normal) + this.q) / n;
    return o < 0 ? void 0 : o;
  }
  get mirrorMatrix() {
    return [1 - 2 * this.normal[0] * this.normal[0], -2 * this.normal[0] * this.normal[1], -2 * this.normal[0] * this.normal[2], 0, -2 * this.normal[1] * this.normal[0], 1 - 2 * this.normal[1] * this.normal[1], -2 * this.normal[1] * this.normal[2], 0, -2 * this.normal[2] * this.normal[0], -2 * this.normal[2] * this.normal[1], 1 - 2 * this.normal[2] * this.normal[2], 0, -2 * this.normal[0] * this.q, -2 * this.normal[1] * this.q, -2 * this.normal[2] * this.q, 1];
  }
}
class go {
  constructor(t, n) {
    this.top = 0, this.bottom = 0, this.left = 0, this.right = 0, this.near = 0, this.far = 0, this.pointPrp = T.zero(), this.pointNearTopLeft = T.zero(), this.pointNearTopRight = T.zero(), this.pointNearBottomLeft = T.zero(), this.pointNearBottomRight = T.zero(), this.pointFarTopLeft = T.zero(), this.pointFarTopRight = T.zero(), this.pointFarBottomLeft = T.zero(), this.pointFarBottomRight = T.zero(), this.up = T.zero(), this.top = t.top, this.bottom = t.bottom, this.left = t.left, this.right = t.right, this.near = t.near, this.far = t.far, this.pointPrp = M.transformPoint(n, T.zero()), this.up = M.transformDirection(n, T.yAxis());
    const o = [this.left, this.top, -this.near], i = [this.right, this.top, -this.near], e = [this.left, this.bottom, -this.near], a = [this.right, this.bottom, -this.near];
    this.pointNearTopLeft = M.transformPoint(n, o), this.pointNearTopRight = M.transformPoint(n, i), this.pointNearBottomLeft = M.transformPoint(n, e), this.pointNearBottomRight = M.transformPoint(n, a);
    const c = this.far / this.near, p = s.mulScalar(o, c), f = s.mulScalar(i, c), R = s.mulScalar(e, c), L = s.mulScalar(a, c);
    let u, m, b;
    this.pointFarTopLeft = M.transformPoint(n, p), this.pointFarTopRight = M.transformPoint(n, f), this.pointFarBottomRight = M.transformPoint(n, L), this.pointFarBottomLeft = M.transformPoint(n, R), u = s.subtract(this.pointNearTopLeft, this.pointPrp), m = s.subtract(this.pointNearTopRight, this.pointPrp), b = s.cross(u, m), this.planeTop = new E(b, this.pointPrp), u = s.subtract(this.pointNearBottomRight, this.pointPrp), m = s.subtract(this.pointNearBottomLeft, this.pointPrp), b = s.cross(u, m), this.planeBottom = new E(b, this.pointPrp), u = s.subtract(this.pointNearBottomLeft, this.pointPrp), m = s.subtract(this.pointNearTopLeft, this.pointPrp), b = s.cross(u, m), this.planeLeft = new E(b, this.pointPrp), u = s.subtract(this.pointNearTopRight, this.pointPrp), m = s.subtract(this.pointNearBottomRight, this.pointPrp), b = s.cross(u, m), this.planeRight = new E(b, this.pointPrp), u = s.subtract(this.pointNearBottomLeft, this.pointNearBottomRight), m = s.subtract(this.pointNearTopRight, this.pointNearBottomRight), b = s.cross(u, m), this.planeNear = new E(b, this.pointNearBottomRight), u = s.subtract(this.pointNearBottomLeft, this.pointNearBottomRight), m = s.subtract(this.pointNearTopRight, this.pointNearBottomRight), b = s.cross(u, m), this.planeZero = new E(b, this.pointPrp), u = s.subtract(this.pointFarTopRight, this.pointFarBottomRight), m = s.subtract(this.pointFarBottomLeft, this.pointFarBottomRight), b = s.cross(u, m), this.planeFar = new E(b, this.pointFarBottomRight);
  }
  testWithoutNearAndFar(t) {
    return t.position(this.planeLeft) === I.back ? Y.left : t.position(this.planeRight) === I.back ? Y.right : t.position(this.planeBottom) === I.back ? Y.bottom : t.position(this.planeTop) === I.back ? Y.top : Y.none;
  }
}
var D, to, oo;
(function(r) {
  r.one = "one", r.two = "two", r.three = "three", r.four = "four";
})(D || (D = {})), function(r) {
  r.sampleCount = function(t) {
    switch (t) {
      case r.one:
        return 1;
      case r.two:
        return 2;
      case r.four:
        return 4;
      default:
        return 1;
    }
  };
}(D || (D = {})), function(r) {
  r.fill = "fill", r.user = "user", r.viewport = "viewport";
}(to || (to = {}));
class Tt {
  constructor(t, n) {
    this.width = t, this.height = n;
  }
  get aspect() {
    return this.width / this.height;
  }
}
class q {
  constructor(t, n) {
    this.direction = t, this.origin = n;
  }
  static initPoint(t, n) {
    const o = s.normalize(s.subtract(t, n));
    return new q(o, n);
  }
  point(t) {
    return s.add(this.origin, s.mulScalar(this.direction, t));
  }
  distance(t) {
    const n = s.subtract(t, this.origin), o = s.mulScalar(this.direction, s.dot(n, this.direction));
    return s.length(s.subtract(n, o));
  }
}
(function(r) {
  r.color = "color", r.modulator = "modulator";
})(oo || (oo = {}));
var no;
(function(r) {
  r.opaque = "opaque", r.transparent = "transparent", r.label = "label";
})(no || (no = {}));
var ro;
(function(r) {
  r[r.environment = 1] = "environment", r[r.matte = 2] = "matte", r[r.mirror = 4] = "mirror", r[r.multiLayer = 8] = "multiLayer", r[r.null = 16] = "null", r[r.seam = 32] = "seam", r[r.standard = 64] = "standard", r[r.transparent = 128] = "transparent", r[r.label = 256] = "label", r[r.all = 511] = "all";
})(ro || (ro = {}));
var io, ao;
(function(r) {
  r[r.model = 0] = "model", r[r.mirror = 1] = "mirror";
})(io || (io = {}));
(function(r) {
  r.fill = "fill", r.lighting = "lighting", r.material = "material", r.handDrawing = "handDrawing";
})(ao || (ao = {}));
var so, co, eo, fo;
(function(r) {
  r.bool = "bool", r.int = "int", r.float = "float", r.color = "color", r.length = "length", r.texture = "texture", r.levels = "levels", r.cameraResponseEnum = "cameraResponseEnum";
})(so || (so = {})), function(r) {
  r.negative = "negative", r.blackAndWhite = "blackAndWhite", r.sepia = "sepia", r.grayscale = "grayscale", r.colorFilter = "colorFilter", r.blurHorizontal = "blurHorizontal", r.blurVertical = "blurVertical", r.grainGeneratorPerlin = "grainGeneratorPerlin", r.grainGeneratorMd4 = "grainGeneratorMd4", r.edgeDetector = "edgeDetector", r.combine = "combine", r.erodeHorizontal = "erodeHorizontal", r.erodeVertical = "erodeVertical", r.erode = "erode", r.dilateHorizontal = "dilateHorizontal", r.dilateVertical = "dilateVertical", r.dilate = "dilate", r.adjustColor = "adjustColor", r.automaticToneMapping = "automaticToneMapping", r.blur = "blur", r.grain = "grain", r.handDrawing = "handDrawing", r.store = "store", r.restore = "restore", r.get3DImage = "get3DImage", r.glowThresholder = "glowThresholder", r.glowCombiner = "glowCombiner", r.glow = "glow", r.sharpenCombiner = "sharpenCombiner", r.sharpen = "sharpen", r.multiplyAdd = "multiplyAdd", r.bloom = "bloom", r.levels = "levels", r.bloomCombiner = "bloomCombiner", r.reinhardToneMapping = "reinhardToneMapping", r.dragoToneMapping = "dragoToneMapping", r.bloomThresholder = "bloomThresholder", r.vignetting = "vignetting", r.cameraResponse = "cameraResponse";
}(co || (co = {}));
(function(r) {
  r.pixel = "pixel", r.millimeter = "millimeter", r.none = "none";
})(eo || (eo = {}));
(function(r) {
  r.never = "never", r.always = "always", r.surface = "surface", r.product = "product";
})(fo || (fo = {}));
class Q {
  static initCubeFace(t, n, o) {
    let i = [0, 0, 0];
    const e = s.subtract(n, t), a = s.mulScalar([0, 1, 0], s.length(e)), c = s.mulScalar(s.normalize(s.cross(e, a)), s.length(e)), p = s.mulScalar(s.normalize(s.cross(a, c)), s.length(e));
    switch (o) {
      case "front":
        n = s.add(t, p), i = s.normalize(a);
        break;
      case "right":
        n = s.add(t, c), i = s.normalize(a);
        break;
      case "back":
        n = s.subtract(t, p), i = s.normalize(a);
        break;
      case "left":
        n = s.subtract(t, c), i = s.normalize(a);
        break;
      case "up":
        n = s.add(t, a), i = s.normalize(s.mulScalar(p, -1));
        break;
      case "down":
        n = s.subtract(t, a), i = s.normalize(p);
    }
    return new Q(n, t, i);
  }
  constructor(t, n, o) {
    this.target = s.copy(t), this.eye = s.copy(n), this.up = s.copy(o);
  }
  get viewVector() {
    return s.subtract(this.target, this.eye);
  }
  get rightVector() {
    return s.normalize(s.cross(this.viewVector, this.up));
  }
  get viewMatrix() {
    return M.inverse(M.lookAt(this.eye, this.target, this.up));
  }
  clone() {
    return new Q(s.copy(this.target), s.copy(this.eye), s.copy(this.up));
  }
}
Q.default = new Q([0, 0, 0], [2, 2, 2], [0, 1, 0]);
var uo;
(function(r, t) {
  t === void 0 && (t = {});
  var n = t.insertAt;
  if (typeof document < "u") {
    var o = document.head || document.getElementsByTagName("head")[0], i = document.createElement("style");
    i.type = "text/css", n === "top" && o.firstChild ? o.insertBefore(i, o.firstChild) : o.appendChild(i), i.styleSheet ? i.styleSheet.cssText = r : i.appendChild(document.createTextNode(r));
  }
})(".ls-viewer-container{display:block;height:100%;overflow:hidden;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:100%}.ls-viewer-container-image,.ls-viewer-container-video{cursor:default;pointer-events:none}.ls-viewer-container-vrcube{cursor:pointer;cursor:-webkit-grab;cursor:grab}.ls-viewer-container-vrcube-grabbing{cursor:move;cursor:-webkit-grabbing;cursor:grabbing}.ls-viewer-container-vrobject{cursor:move;cursor:-webkit-grab;cursor:grab}.ls-viewer-container-vrobject-grabbing{cursor:move;cursor:-webkit-grabbing;cursor:grabbing}.ls-viewer-container-loading{cursor:progress}.ls-viewer-canvas{opacity:0;position:absolute;-webkit-transition:opacity .5s;transition:opacity .5s}.ls-viewer-video{position:absolute}");
(function(r) {
  var t, n, o;
  (t = r.SunShadowQualityMode || (r.SunShadowQualityMode = {})).VeryLow = "veryLow", t.Low = "low", t.Medium = "medium", t.Fine = "fine", t.Ultra = "ultra", (n = r.SunShadowSmoothnessMode || (r.SunShadowSmoothnessMode = {})).None = "none", n.Weak = "weak", n.Normal = "normal", n.Fine = "fine", n.UltraFine = "ultraFine", n.Max = "max", (o = r.SunUseCaseMode || (r.SunUseCaseMode = {})).Manual = "manual", o.ExtractedFromEnv = "extractedFromEnv";
})(uo || (uo = {}));
var N = /* @__PURE__ */ ((r) => (r.back = "back", r.front = "front", r.left = "left", r.right = "right", r.up = "up", r.down = "down", r))(N || {}), Ro = /* @__PURE__ */ ((r) => (r.X = "x", r.Y = "y", r))(Ro || {}), z = /* @__PURE__ */ ((r) => (r.PP = "PP", r.PC = "PC", r.CP = "CP", r.CC = "CC", r))(z || {}), g = /* @__PURE__ */ ((r) => (r.FRONT = "front", r.BACK = "back", r.LEFT = "left", r.RIGHT = "right", r))(g || {});
class vo {
  static boxMapping(t) {
    const n = [], i = 2 * Math.ceil(Math.max(...[1, 1, 1]) + 0.5);
    for (let e = 0; e < t.vertices.length; e += 3) {
      const a = t.normals.slice(e, e + 3), c = Math.abs(a[0]), p = Math.abs(a[1]), f = Math.abs(a[2]), R = [a[0], a[2], 0], L = s.length(R);
      let u;
      p > L ? a[1] > 0 ? u = 2 : u = 3 : c > f ? a[0] > 0 ? u = 0 : u = 1 : a[1] > 0 ? u = 4 : u = 5;
      const m = t.vertices[e], b = t.vertices[e + 1], l = t.vertices[e + 2];
      switch (u) {
        case 0:
          n.push([-l + 0 * i, b]);
          break;
        case 1:
          n.push([l + 1 * i, b]);
          break;
        case 2:
          n.push([m + 2 * i, -l]);
          break;
        case 3:
          n.push([m + 3 * i, l]);
          break;
        case 4:
          n.push([m + 4 * i, b]);
          break;
        case 5:
          n.push([-m + 5 * i, b]);
          break;
      }
    }
    return n.flat().map((e) => e + 0.5);
  }
}
class Mo {
  static computeNormals(t) {
    const n = [];
    for (let o = 0; o < t.vertices.length; o += 3)
      n.push(...this.vertexNormal(t, o / 3));
    return n;
  }
  static triangleNormal(t, n) {
    const o = [
      t.vertices[t.indexes[n * 3] * 3],
      //
      t.vertices[t.indexes[n * 3] * 3 + 1],
      t.vertices[t.indexes[n * 3] * 3 + 2]
    ], i = [
      t.vertices[t.indexes[n * 3 + 1] * 3],
      //
      t.vertices[t.indexes[n * 3 + 1] * 3 + 1],
      t.vertices[t.indexes[n * 3 + 1] * 3 + 2]
    ], e = [
      t.vertices[t.indexes[n * 3 + 2] * 3],
      //
      t.vertices[t.indexes[n * 3 + 2] * 3 + 1],
      t.vertices[t.indexes[n * 3 + 2] * 3 + 2]
    ], a = s.cross(s.subtract(i, o), s.subtract(e, o));
    return [...s.normalize(a)];
  }
  static vertexNormal(t, n) {
    const o = this.vertexTriangles(t, n), i = [0, 0, 0];
    for (const e of o)
      s.add(i, this.triangleNormal(t, e), i);
    return [...s.normalize(i)];
  }
  static vertexTriangles(t, n) {
    return t.indexes.reduce((o, i, e) => i === n ? [...o, Math.trunc(e / 3)] : o, []);
  }
}
class C {
  constructor(t = [], n = [], o = [], i = []) {
    this.indexes = t, this.vertices = n, this.normals = o, this.uvs = i;
  }
  computeNormals() {
    this.normals = Mo.computeNormals(this);
  }
  dress() {
    this.uvs = vo.boxMapping(this);
  }
}
class d {
  static create(t, n, o, i) {
    const e = d.triangles(), a = d.vertices(t, n, o, i), c = new C(e, a);
    return c.computeNormals(), c.dress(), c;
  }
  static triangles() {
    return [
      [0, 1, 2],
      [3, 1, 0],
      [4, 5, 6],
      [4, 7, 5],
      [8, 9, 10],
      [8, 11, 9],
      [12, 13, 14],
      [15, 13, 12],
      [16, 17, 18],
      [19, 17, 16],
      [20, 21, 22],
      [20, 23, 21]
    ].flat();
  }
  static vertices(t, n, o, i) {
    const e = Math.max(n, o);
    return [
      // Front
      [t / 2, e / 2 - o, i / 2],
      [-t / 2, e / 2, i / 2],
      [-t / 2, e / 2 - n, i / 2],
      [t / 2, e / 2, i / 2],
      // Back
      [t / 2, e / 2 - o, -i / 2],
      [-t / 2, e / 2, -i / 2],
      [t / 2, e / 2, -i / 2],
      [-t / 2, e / 2 - n, -i / 2],
      // Left
      [-t / 2, e / 2, -i / 2],
      [-t / 2, e / 2 - n, i / 2],
      [-t / 2, e / 2, i / 2],
      [-t / 2, e / 2 - n, -i / 2],
      // Right
      [t / 2, e / 2, -i / 2],
      [t / 2, e / 2 - o, i / 2],
      [t / 2, e / 2 - o, -i / 2],
      [t / 2, e / 2, i / 2],
      // Top
      [-t / 2, e / 2, i / 2],
      [t / 2, e / 2, -i / 2],
      [-t / 2, e / 2, -i / 2],
      [t / 2, e / 2, i / 2],
      // Bottom
      [-t / 2, e / 2 - n, i / 2],
      [t / 2, e / 2 - o, -i / 2],
      [t / 2, e / 2 - o, i / 2],
      [-t / 2, e / 2 - n, -i / 2]
    ].flat();
  }
}
function X(r, t) {
  return {
    tag: t,
    vertices: r.vertices.map((n) => W(n)),
    normals: r.normals.map((n) => W(n)),
    uvs: r.uvs.map((n) => W(n))
  };
}
function W(r) {
  return Math.round(r * 1e3) / 1e3;
}
function Wo(r) {
  const t = Po(r);
  return H.initPoints(
    [
      -r.overall.width / 100 / 2,
      //
      -t,
      -r.overall.depth / 100 / 2
    ],
    [
      r.overall.width / 100 / 2,
      //
      0,
      r.overall.depth / 100 / 2
    ]
  );
}
function Po(r) {
  return Math.max(
    ...Object.values(r.parts).map((t) => Lo(t))
  );
}
function Lo(r) {
  return Array.isArray(r.height) ? Math.max(...r.height) / 100 : r.height / 100;
}
function Xo(r) {
  return Object.entries(r.parts).map(([t, n]) => {
    const o = xo(t), i = Fo(t, n, r), e = To(t, n, r).map((c) => W(c)), a = Co(t).map((c) => W(c));
    return {
      database: r.database,
      configuration: o,
      materials: [{ tag: t.toUpperCase() }],
      surfaces: i,
      translation: {
        x: e[0],
        y: e[1],
        z: e[2]
      },
      rotation: {
        x: a[0],
        y: a[1],
        z: a[2]
      }
    };
  });
}
function xo(r, t, n) {
  return `PART.${r.toUpperCase()}`;
}
function Fo(r, t, n) {
  const o = d.create(
    t.width / 100,
    //
    (Array.isArray(t.height) ? t.height[0] : t.height) / 100,
    (Array.isArray(t.height) ? t.height[1] : t.height) / 100,
    n.thickness / 100
  );
  return [
    X(o, r.toUpperCase())
    //
  ];
}
function To(r, t, n) {
  const o = n.overall.width / 100 / 2, i = -Lo(t) / 2, e = n.overall.depth / 100 / 2, a = n.thickness / 100 / 2, c = n.parts;
  return {
    [z.PP]: {
      [g.FRONT]: [
        0,
        //
        i,
        e - a
      ],
      [g.BACK]: [
        0,
        //
        i,
        -e + a
      ],
      [g.LEFT]: [
        -o + a,
        //
        i,
        (c.front ? 0 : a) - (c.back ? 0 : a)
      ],
      [g.RIGHT]: [
        o - a,
        //
        i,
        (c.front ? 0 : a) - (c.back ? 0 : a)
      ]
    },
    [z.PC]: {
      [g.FRONT]: [
        0,
        //
        i,
        e - a
      ],
      [g.BACK]: [
        (c.right ? 0 : a) - (c.left ? 0 : a),
        //
        i,
        -e + a
      ],
      [g.LEFT]: [
        -o + a,
        //
        i,
        -a + (c.front ? 0 : a)
      ],
      [g.RIGHT]: [
        0 + o - a,
        //
        i,
        -a + (c.front ? 0 : a)
      ]
    },
    [z.CP]: {
      [g.FRONT]: [
        (c.right ? 0 : a) - (c.left ? 0 : a),
        //
        i,
        e - a
      ],
      [g.BACK]: [
        0,
        //
        i,
        -e + a
      ],
      [g.LEFT]: [
        -o + a,
        //
        i,
        a - (c.back ? 0 : a)
      ],
      [g.RIGHT]: [
        0 + o - a,
        //
        i,
        a - (c.back ? 0 : a)
      ]
    },
    [z.CC]: {
      [g.FRONT]: [
        (c.right ? 0 : a) - (c.left ? 0 : a),
        //
        i,
        e - a
      ],
      [g.BACK]: [
        (c.right ? 0 : a) - (c.left ? 0 : a),
        //
        i,
        -e + a
      ],
      [g.LEFT]: [
        -o + a,
        //
        i,
        0
      ],
      [g.RIGHT]: [
        o - a,
        //
        i,
        0
      ]
    }
  }[n.assemblyType][r];
}
function Co(r) {
  switch (r) {
    case g.FRONT:
      return [0, 0, 0];
    case g.BACK:
      return [0, 180, 0];
    case g.LEFT:
      return [0, -90, 0];
    case g.RIGHT:
      return [0, 90, 0];
    default:
      return [0, 0, 0];
  }
}
function Qo(r, t, n) {
  const o = {
    target: { x: r.center[0], y: r.center[1], z: r.center[2] },
    eye: { x: r.center[0], y: r.center[1], z: r.center[2] },
    up: yo(t)
  }, i = No(r, t, n);
  switch (t) {
    case N.back:
      o.target.z = r.pointMin[2], o.eye.z = o.target.z - i;
      break;
    case N.front:
      o.target.z = r.pointMax[2], o.eye.z = o.target.z + i;
      break;
    case N.left:
      o.target.x = r.pointMin[0], o.eye.x = o.target.x - i;
      break;
    case N.right:
      o.target.x = r.pointMax[0], o.eye.x = o.target.x + i;
      break;
    case N.up:
      o.target.y = r.pointMax[1], o.eye.y = o.target.y + i;
      break;
    case N.down:
      o.target.y = r.pointMin[1], o.eye.y = o.target.y - i;
      break;
  }
  return o;
}
function mo(r, t) {
  switch (t) {
    case N.back:
    case N.front:
      return new Tt(r.dimension[0], r.dimension[1]);
    case N.left:
    case N.right:
      return new Tt(r.dimension[2], r.dimension[1]);
    case N.up:
    case N.down:
      return new Tt(r.dimension[0], r.dimension[2]);
  }
}
function No(r, t, n) {
  return Math.max(zo(r, t, n), ko(r, t));
}
function zo(r, t, n) {
  const o = mo(r, t), e = 45 * Math.PI / 180, a = 2 * Math.atan(n * Math.tan(e / 2));
  return o.width / 2 / Math.tan(a / 2);
}
function ko(r, t) {
  const n = mo(r, t), i = 45 * Math.PI / 180;
  return n.height / 2 / Math.tan(i / 2);
}
function yo(r) {
  switch (r) {
    case N.back:
    case N.front:
    case N.left:
    case N.right:
      return { x: 0, y: 1, z: 0 };
    case N.up:
      return { x: 0, y: 0, z: -1 };
    case N.down:
      return { x: 0, y: 0, z: 1 };
  }
}
function $o(r, t, n, o, i, e) {
  const a = So(r, i, e), c = Math.degreesToRadians(n), p = o === Ro.X ? c : 2 * Math.atan(t * Math.tan(c / 2)), f = Eo(r, t, p, i, e, a);
  return f.target = [...f.target].map((R) => Math.round(R * 1e3) / 1e3), f.eye = [...f.eye].map((R) => Math.round(R * 1e3) / 1e3), f.up = [...f.up].map((R) => Math.round(R * 1e3) / 1e3), {
    eye: { x: f.eye[0], y: f.eye[1], z: f.eye[2] },
    target: { x: f.target[0], y: f.target[1], z: f.target[2] },
    up: { x: f.up[0], y: f.up[1], z: f.up[2] }
  };
}
function So(r, t, n) {
  const o = [r.pointMax[0], r.center[1], r.pointMax[2]], i = Ct(o, 10, t, n), e = new E([1, 0, 0], [0, 0, 0]), a = s.add(i.eye, s.mulScalar(i.viewVector, e.intersection(new q(i.viewVector, i.eye)))), c = new E([0, 0, 1], [0, 0, 0]), p = s.add(i.eye, s.mulScalar(i.viewVector, c.intersection(new q(i.viewVector, i.eye))));
  return [r.center[0], (a[1] + p[1]) / 2, r.center[2]];
}
function Eo(r, t, n, o, i, e) {
  const a = Ct(e, 10, o, i), c = Io(r, a, n, t);
  return Ct(e, c, o, i);
}
function Ct(r, t, n, o, i = 0) {
  const e = M.rotationY(Math.degreesToRadians(n)), a = M.rotationX(Math.degreesToRadians(-o)), c = M.rotationZ(Math.degreesToRadians(i)), p = M.multiply(e, M.multiply(a, c)), f = M.transformDirection(p, [0, 0, -1]), R = r, L = s.subtract(r, s.mulScalar(f, t)), u = M.transformDirection(p, [0, 1, 0]);
  return new j(R, L, u);
}
function Io(r, t, n, o) {
  const i = Math.tan(n / 2), e = i / o, a = new lo(!0, -i, i, -e, e, 1, 1.1), c = M.lookAt(t.eye, t.target, t.up), p = new go(a, c);
  let f, R, L, u;
  for (const G of r.points)
    !f && _(r.points, G, p.planeLeft.normal) && (f = G), !R && _(r.points, G, p.planeRight.normal) && (R = G), !L && _(r.points, G, p.planeTop.normal) && (L = G), !u && _(r.points, G, p.planeBottom.normal) && (u = G);
  const m = t.target, b = s.normalize(s.subtract(t.eye, t.target)), F = new E(p.planeLeft.normal, f).intersection(new q(b, m)), O = new E(p.planeRight.normal, R).intersection(new q(b, m)), B = new E(p.planeTop.normal, L).intersection(new q(b, m)), xt = new E(p.planeBottom.normal, u).intersection(new q(b, m));
  return Math.max(F, O, B, xt);
}
function _(r, t, n) {
  for (const o of r)
    if (o !== t && s.dot(n, s.subtract(t, o)) > 0)
      return !1;
  return !0;
}
class v {
  constructor(t, n, o, i) {
    this.topRight = i, this.topLeft = o, this.bottomLeft = t, this.bottomRight = n;
  }
  static init() {
    return new v(s.create(), s.create(), s.create(), s.create());
  }
  clone() {
    return new v(s.copy(this.bottomLeft), s.copy(this.bottomRight), s.copy(this.topLeft), s.copy(this.topRight));
  }
}
var P = /* @__PURE__ */ ((r) => (r[r.FRONT = 0] = "FRONT", r[r.LEFT = 1] = "LEFT", r[r.RIGHT = 2] = "RIGHT", r))(P || {});
class x {
  constructor(t, n, o, i) {
    this.hammeredHeight = 1e-3, this.outer = t, this.hammeredOffset = o, this.sideHammeredOffset = i, this.slopeType = n, this.inner = this.computeInner(), this.finish = this.computeFinish(), [
      1,
      2
      /* RIGHT */
    ].includes(this.slopeType) && this.rotate();
  }
  computeInner() {
    const t = Math.abs(this.outer.bottomRight[2] - this.outer.topRight[2]), n = Math.abs(this.outer.bottomLeft[0] - this.outer.topLeft[0]), o = Math.abs(this.outer.bottomRight[0] - this.outer.topRight[0]), i = Math.atan(t / n) === 0 ? Math.PI / 2 : Math.atan(t / n), e = Math.atan(t / o) === 0 ? Math.PI / 2 : Math.atan(t / o), a = this.sideHammeredOffset / Math.sin(i), c = this.sideHammeredOffset / Math.sin(e), p = s.subtract(this.outer.topLeft, this.outer.bottomLeft), f = s.subtract(this.outer.topRight, this.outer.bottomRight), R = (this.outer.bottomRight[0] + this.outer.bottomLeft[0]) / 2, L = new q(p, s.add(this.outer.bottomLeft, s.create(this.outer.bottomLeft[0] - R < 0 ? a : -a, 0, 0))), u = new q(f, s.subtract(this.outer.bottomRight, s.create(this.outer.bottomRight[0] - R < 0 ? -c : c, 0, 0))), m = Math.atan((this.outer.topLeft[2] - this.outer.bottomLeft[2]) / (this.outer.topLeft[1] - this.outer.bottomLeft[1])), b = Math.abs(Math.cos(m) * this.hammeredOffset), l = Math.abs(Math.sin(m) * this.hammeredOffset), F = (this.outer.topLeft[2] + this.outer.bottomLeft[2]) / 2, S = s.add(this.outer.bottomLeft, s.create(0, b, this.outer.bottomLeft[2] - F < 0 ? l : -l)), O = s.subtract(this.outer.topLeft, s.create(0, b, this.outer.topLeft[2] - F < 0 ? -l : l)), h = s.subtract(s.create(0, this.outer.topRight[1], this.outer.topRight[2]), s.create(0, this.outer.bottomRight[1], this.outer.bottomRight[2])), B = new E(h, S), w = new E(h, O), xt = s.add(L.origin, s.mulScalar(L.direction, B.intersection(L))), G = s.add(u.origin, s.mulScalar(u.direction, B.intersection(u)));
    let V = s.add(L.origin, s.mulScalar(L.direction, w.intersection(L))), U = s.add(u.origin, s.mulScalar(u.direction, w.intersection(u)));
    switch (this.slopeType) {
      case 1:
        U = V[0] > U[0] ? s.create(V[0], V[1], V[2]) : U;
        break;
      case 2:
        V = V[0] < U[0] ? s.create(U[0], U[1], U[2]) : V;
        break;
    }
    return new v(xt, G, V, U);
  }
  computeFinish() {
    const t = (this.outer.topLeft[2] + this.outer.bottomLeft[2]) / 2, n = Math.atan((this.outer.topLeft[2] - this.outer.bottomLeft[2]) / (this.outer.topLeft[1] - this.outer.bottomLeft[1])), o = Math.PI / 2 - n, i = Math.abs(Math.cos(o) * this.hammeredHeight), e = Math.abs(Math.sin(o) * this.hammeredHeight), a = s.add(this.inner.bottomLeft, s.create(0, -i, this.outer.bottomLeft[2] - t < 0 ? e : -e)), c = s.add(this.inner.bottomRight, s.create(0, -i, this.outer.bottomLeft[2] - t < 0 ? e : -e)), p = s.add(this.inner.topLeft, s.create(0, -i, this.outer.bottomLeft[2] - t < 0 ? -e : e)), f = s.add(this.inner.topRight, s.create(0, -i, this.outer.bottomLeft[2] - t < 0 ? -e : e));
    return new v(a, c, p, f);
  }
  rotate() {
    const t = this.outer.clone();
    this.outer.bottomLeft[0] = t.bottomLeft[2], this.outer.bottomLeft[2] = t.bottomLeft[0], this.outer.topLeft[0] = t.topLeft[2], this.outer.topLeft[2] = t.topLeft[0], this.outer.bottomRight[0] = t.bottomRight[2], this.outer.bottomRight[2] = t.bottomRight[0], this.outer.topRight[0] = t.topRight[2], this.outer.topRight[2] = t.topRight[0];
    const n = this.inner.clone();
    this.inner.bottomLeft[0] = n.bottomLeft[2], this.inner.bottomLeft[2] = n.bottomLeft[0], this.inner.topLeft[0] = n.topLeft[2], this.inner.topLeft[2] = n.topLeft[0], this.inner.bottomRight[0] = n.bottomRight[2], this.inner.bottomRight[2] = n.bottomRight[0], this.inner.topRight[0] = n.topRight[2], this.inner.topRight[2] = n.topRight[0];
    const o = this.finish.clone();
    this.finish.bottomLeft[0] = o.bottomLeft[2], this.finish.bottomLeft[2] = o.bottomLeft[0], this.finish.topLeft[0] = o.topLeft[2], this.finish.topLeft[2] = o.topLeft[0], this.finish.bottomRight[0] = o.bottomRight[2], this.finish.bottomRight[2] = o.bottomRight[0], this.finish.topRight[0] = o.topRight[2], this.finish.topRight[2] = o.topRight[0];
  }
}
class tt {
  static create(t, n) {
    return (o, i, e, a, c, p, f) => {
      const R = tt.triangles(), L = tt.vertices(o, i, e, a, c, p, f, t, n), u = new C(R, L);
      return u.computeNormals(), u.dress(), u;
    };
  }
  static triangles() {
    return [
      [0, 1, 2],
      [3, 1, 0],
      [4, 5, 6],
      [4, 7, 5],
      [8, 9, 10],
      [11, 8, 10]
    ].flat();
  }
  static vertices(t, n, o, i, e, a, c, p, f) {
    const R = new v(
      s.create(-i / 2, -o / 2 + n, -t / 2),
      //
      s.create(i / 2, -o / 2 + n, -t / 2),
      s.create(-i / 2, o / 2, -(t / 2 - e + c)),
      s.create(-i / 2 + c, o / 2, -(t / 2 - e + c))
    ), L = new x(R, P.LEFT, p, f), u = new v(
      s.create(i / 2, -o / 2 + n, t / 2),
      //
      s.create(-i / 2, -o / 2 + n, t / 2),
      s.create(-i / 2 + c, o / 2, t / 2 - a + c),
      s.create(-i / 2, o / 2, t / 2 - a + c)
    ), m = new x(u, P.RIGHT, p, f), b = new v(
      s.create(-t / 2, -o / 2 + n, i / 2),
      //
      s.create(t / 2, -o / 2 + n, i / 2),
      s.create(-(t / 2 - e + c), o / 2, -i / 2 + c),
      s.create(t / 2 - a + c, o / 2, -i / 2 + c)
    ), l = new x(b, P.FRONT, p, f);
    return [
      ...m.finish.topLeft,
      //
      ...m.finish.bottomRight,
      ...m.finish.topRight,
      ...m.finish.bottomLeft,
      ...L.finish.bottomLeft,
      ...L.finish.topRight,
      ...L.finish.topLeft,
      ...L.finish.bottomRight,
      ...l.finish.bottomLeft,
      ...l.finish.bottomRight,
      ...l.finish.topRight,
      ...l.finish.topLeft
    ];
  }
}
class ot {
  static create(t, n) {
    return (o, i, e, a, c, p, f) => {
      const R = ot.triangles(), L = ot.vertices(o, i, e, a, c, p, f, t, n), u = new C(R, L);
      return u.computeNormals(), u.dress(), u;
    };
  }
  static triangles() {
    return [
      [0, 1, 2],
      [2, 1, 3],
      [4, 5, 6],
      [4, 6, 7],
      [8, 9, 10],
      [11, 8, 10],
      [12, 13, 14],
      [15, 12, 14],
      [16, 17, 18],
      [16, 19, 17],
      [20, 21, 22],
      [22, 21, 23],
      [24, 25, 26],
      [26, 25, 27],
      [28, 29, 30],
      [30, 29, 31],
      [32, 33, 34],
      [32, 35, 36],
      [32, 37, 33],
      [34, 35, 32],
      [35, 38, 36],
      [33, 37, 38],
      [38, 39, 36],
      [37, 39, 38],
      [40, 41, 42],
      [43, 40, 44],
      [43, 45, 46],
      [41, 47, 46],
      [45, 41, 46],
      [44, 45, 43],
      [44, 40, 42],
      [40, 47, 41],
      [48, 49, 50],
      [51, 52, 50],
      [49, 51, 50],
      [53, 52, 51],
      [54, 55, 56],
      [56, 55, 57],
      [58, 59, 60],
      [58, 61, 62],
      [58, 63, 59],
      [60, 61, 58],
      [61, 64, 62],
      [65, 64, 61],
      [65, 59, 64],
      [59, 63, 64],
      [66, 67, 68],
      [69, 67, 66],
      [70, 71, 72],
      [73, 70, 72],
      [74, 75, 76],
      [74, 77, 75],
      [78, 79, 80],
      [81, 78, 80],
      [82, 83, 84],
      [84, 83, 85],
      [86, 87, 88],
      [89, 86, 88],
      [90, 91, 92],
      [92, 91, 93],
      [94, 95, 96],
      [97, 94, 96]
    ].flat();
  }
  static vertices(t, n, o, i, e, a, c, p, f) {
    const R = new v(
      s.create(-i / 2, -o / 2 + n, -t / 2),
      //
      s.create(i / 2, -o / 2 + n, -t / 2),
      s.create(-i / 2, o / 2, -(t / 2 - e + c)),
      s.create(-i / 2 + c, o / 2, -(t / 2 - e + c))
    ), L = new x(R, P.LEFT, p, f), u = new v(
      s.create(i / 2, -o / 2 + n, t / 2),
      //
      s.create(-i / 2, -o / 2 + n, t / 2),
      s.create(-i / 2 + c, o / 2, t / 2 - a + c),
      s.create(-i / 2, o / 2, t / 2 - a + c)
    ), m = new x(u, P.RIGHT, p, f), b = new v(
      s.create(-t / 2, -o / 2 + n, i / 2),
      //
      s.create(t / 2, -o / 2 + n, i / 2),
      s.create(-(t / 2 - e + c), o / 2, -i / 2 + c),
      s.create(t / 2 - a + c, o / 2, -i / 2 + c)
    ), l = new x(b, P.FRONT, p, f), F = new v(
      s.create(-t / 2, -o / 2, i / 2),
      //
      s.create(t / 2, -o / 2, i / 2),
      s.create(-t / 2, -o / 2, -i / 2),
      s.create(t / 2, -o / 2, -i / 2)
    );
    return [
      ...m.inner.bottomRight,
      ...m.inner.topRight,
      ...m.finish.bottomRight,
      ...m.finish.topRight,
      ...l.inner.bottomRight,
      ...l.inner.topRight,
      ...l.finish.topRight,
      ...l.finish.bottomRight,
      ...L.inner.topRight,
      ...L.inner.topLeft,
      ...L.finish.topLeft,
      ...L.finish.topRight,
      ...L.inner.bottomRight,
      ...L.inner.topRight,
      ...L.finish.topRight,
      ...L.finish.bottomRight,
      ...L.finish.bottomRight,
      ...L.inner.bottomLeft,
      ...L.inner.bottomRight,
      ...L.finish.bottomLeft,
      ...m.outer.bottomLeft,
      ...L.outer.bottomRight,
      ...F.bottomRight,
      ...F.bottomLeft,
      ...m.outer.bottomRight,
      ...m.outer.bottomLeft,
      ...F.topRight,
      ...F.bottomRight,
      ...F.bottomRight,
      ...F.bottomLeft,
      ...F.topRight,
      ...F.topLeft,
      ...L.outer.topRight,
      ...l.inner.bottomLeft,
      ...l.inner.topLeft,
      ...l.inner.topRight,
      ...m.outer.topLeft,
      ...L.outer.bottomRight,
      ...l.inner.bottomRight,
      ...m.outer.bottomLeft,
      ...m.outer.topLeft,
      ...m.inner.bottomLeft,
      ...m.inner.topLeft,
      ...m.outer.topRight,
      ...m.inner.topRight,
      ...m.inner.bottomRight,
      ...m.outer.bottomRight,
      ...m.outer.bottomLeft,
      ...L.outer.bottomLeft,
      ...L.outer.topLeft,
      ...F.topLeft,
      ...m.outer.topRight,
      ...F.topRight,
      ...m.outer.bottomRight,
      ...L.outer.topRight,
      ...m.outer.topLeft,
      ...L.outer.topLeft,
      ...m.outer.topRight,
      ...L.outer.bottomLeft,
      ...L.inner.bottomRight,
      ...L.inner.bottomLeft,
      ...L.inner.topLeft,
      ...L.outer.topLeft,
      ...L.outer.bottomRight,
      ...L.outer.topRight,
      ...L.inner.topRight,
      ...l.finish.topLeft,
      ...l.inner.topRight,
      ...l.inner.topLeft,
      ...l.finish.topRight,
      ...l.finish.topLeft,
      ...l.inner.topLeft,
      ...l.inner.bottomLeft,
      ...l.finish.bottomLeft,
      ...L.finish.bottomLeft,
      ...L.inner.topLeft,
      ...L.inner.bottomLeft,
      ...L.finish.topLeft,
      ...l.inner.bottomLeft,
      ...l.inner.bottomRight,
      ...l.finish.bottomRight,
      ...l.finish.bottomLeft,
      ...m.inner.topLeft,
      ...m.inner.bottomLeft,
      ...m.finish.topLeft,
      ...m.finish.bottomLeft,
      ...m.inner.bottomLeft,
      ...m.inner.bottomRight,
      ...m.finish.bottomRight,
      ...m.finish.bottomLeft,
      ...L.outer.bottomRight,
      ...L.outer.bottomLeft,
      ...F.bottomLeft,
      ...F.topLeft,
      ...m.inner.topRight,
      ...m.inner.topLeft,
      ...m.finish.topLeft,
      ...m.finish.topRight
    ];
  }
}
class nt {
  static create(t, n) {
    return (o, i, e, a, c, p) => {
      const f = nt.triangles(), R = nt.vertices(o, i, e, a, c, p, t, n), L = new C(f, R);
      return L.computeNormals(), L.dress(), L;
    };
  }
  static triangles() {
    return [
      [0, 1, 2],
      [1, 3, 2],
      [4, 5, 6],
      [7, 5, 4]
    ].flat();
  }
  static vertices(t, n, o, i, e, a, c, p) {
    const f = new v(
      s.create(-i / 2, -o / 2 + n, -t / 2),
      //
      s.create(i / 2, -o / 2 + n, -t / 2),
      s.create(-i / 2, o / 2, -(t / 2 - e + a)),
      s.create(-i / 2 + a, o / 2, -(t / 2 - e + a))
    ), R = new x(f, P.LEFT, c, p), L = new v(
      s.create(-t / 2, -o / 2 + n, i / 2),
      //
      s.create(t / 2, -o / 2 + n, i / 2),
      s.create(-(t / 2 - e + a), o / 2, -i / 2 + a),
      s.create(t / 2, o / 2, -i / 2 + a)
    ), u = new x(L, P.FRONT, c, p);
    return [
      ...R.finish.bottomRight,
      //
      ...R.finish.topRight,
      ...R.finish.bottomLeft,
      ...R.finish.topLeft,
      ...u.finish.topLeft,
      ...u.finish.bottomRight,
      ...u.finish.topRight,
      ...u.finish.bottomLeft
    ];
  }
}
class rt {
  static create(t, n) {
    return (o, i, e, a, c, p) => {
      const f = rt.triangles(), R = rt.vertices(o, i, e, a, c, p, t, n), L = new C(f, R);
      return L.computeNormals(), L.dress(), L;
    };
  }
  static triangles() {
    return [
      [0, 1, 2],
      [2, 1, 3],
      [4, 5, 6],
      [5, 7, 6],
      [8, 9, 10],
      [11, 9, 12],
      [10, 9, 13],
      [9, 8, 12],
      [11, 12, 14],
      [14, 10, 15],
      [10, 13, 15],
      [11, 14, 15],
      [16, 17, 18],
      [17, 19, 18],
      [20, 21, 22],
      [23, 24, 20],
      [25, 24, 26],
      [24, 27, 20],
      [27, 24, 25],
      [22, 25, 26],
      [22, 21, 25],
      [23, 20, 22],
      [28, 29, 30],
      [28, 31, 29],
      [32, 33, 34],
      [33, 35, 34],
      [36, 37, 38],
      [36, 39, 37],
      [40, 41, 42],
      [43, 40, 42],
      [44, 45, 46],
      [47, 44, 46],
      [48, 49, 50],
      [48, 50, 51],
      [50, 52, 51],
      [53, 54, 55],
      [56, 53, 55],
      [57, 58, 59],
      [60, 57, 59],
      [61, 60, 59],
      [62, 63, 64],
      [65, 63, 62],
      [66, 67, 68],
      [67, 69, 68],
      [70, 71, 72],
      [73, 70, 72]
    ].flat();
  }
  static vertices(t, n, o, i, e, a, c, p) {
    const f = new v(
      s.create(-i / 2, -o / 2 + n, -t / 2),
      //
      s.create(i / 2, -o / 2 + n, -t / 2),
      s.create(-i / 2, o / 2, -(t / 2 - e + a)),
      s.create(-i / 2 + a, o / 2, -(t / 2 - e + a))
    ), R = new x(f, P.LEFT, c, p), L = new v(
      s.create(-t / 2, -o / 2 + n, i / 2),
      //
      s.create(t / 2, -o / 2 + n, i / 2),
      s.create(-(t / 2 - e + a), o / 2, -i / 2 + a),
      s.create(t / 2, o / 2, -i / 2 + a)
    ), u = new x(L, P.FRONT, c, p), m = new v(
      s.create(-t / 2, -o / 2, i / 2),
      //
      s.create(t / 2, -o / 2, i / 2),
      s.create(-t / 2, -o / 2, -i / 2),
      s.create(t / 2, -o / 2, -i / 2)
    ), b = s.create(t / 2, o / 2, -i / 2);
    return [
      ...R.inner.topLeft,
      ...R.finish.topLeft,
      ...R.inner.topRight,
      ...R.finish.topRight,
      ...R.outer.topLeft,
      ...u.outer.topLeft,
      ...b,
      ...u.outer.topRight,
      ...u.inner.topLeft,
      ...u.outer.topLeft,
      ...u.inner.bottomLeft,
      ...u.outer.topRight,
      ...u.inner.topRight,
      ...u.outer.bottomLeft,
      ...u.inner.bottomRight,
      ...u.outer.bottomRight,
      ...u.inner.topLeft,
      ...u.finish.topLeft,
      ...u.inner.topRight,
      ...u.finish.topRight,
      ...R.inner.topLeft,
      ...R.inner.topRight,
      ...u.outer.topLeft,
      ...R.outer.topLeft,
      ...R.outer.bottomLeft,
      ...R.inner.bottomRight,
      ...u.outer.bottomLeft,
      ...R.inner.bottomLeft,
      ...u.inner.bottomLeft,
      ...u.finish.topLeft,
      ...u.inner.topLeft,
      ...u.finish.bottomLeft,
      ...R.inner.topLeft,
      ...R.inner.bottomLeft,
      ...R.finish.topLeft,
      ...R.finish.bottomLeft,
      ...R.finish.bottomRight,
      ...R.inner.bottomLeft,
      ...R.inner.bottomRight,
      ...R.finish.bottomLeft,
      ...R.inner.bottomRight,
      ...R.inner.topRight,
      ...R.finish.topRight,
      ...R.finish.bottomRight,
      ...u.inner.bottomLeft,
      ...u.inner.bottomRight,
      ...u.finish.bottomRight,
      ...u.finish.bottomLeft,
      ...m.topLeft,
      ...R.outer.bottomLeft,
      ...R.outer.topLeft,
      ...m.topRight,
      ...b,
      ...m.bottomLeft,
      ...u.outer.bottomLeft,
      ...R.outer.bottomLeft,
      ...m.topLeft,
      ...m.topRight,
      ...b,
      ...u.outer.topRight,
      ...m.bottomRight,
      ...u.outer.bottomRight,
      ...u.finish.topRight,
      ...u.inner.bottomRight,
      ...u.inner.topRight,
      ...u.finish.bottomRight,
      ...m.topRight,
      ...m.bottomRight,
      ...m.topLeft,
      ...m.bottomLeft,
      ...m.bottomRight,
      ...u.outer.bottomRight,
      ...u.outer.bottomLeft,
      ...m.bottomLeft
    ];
  }
}
class it {
  static create(t, n) {
    return (o, i, e, a, c) => {
      const p = it.triangles(), f = it.vertices(o, i, e, a, c, t, n), R = new C(p, f);
      return R.computeNormals(), R.dress(), R;
    };
  }
  static triangles() {
    return [
      [0, 1, 2],
      [3, 1, 0]
    ].flat();
  }
  static vertices(t, n, o, i, e, a, c) {
    const p = new v(
      s.create(-t / 2, -o / 2 + n, i / 2),
      //
      s.create(t / 2, -o / 2 + n, i / 2),
      s.create(-t / 2, o / 2, -i / 2 + e),
      s.create(t / 2, o / 2, -i / 2 + e)
    ), f = new x(p, P.FRONT, a, c);
    return [
      ...f.finish.bottomLeft,
      //
      ...f.finish.topRight,
      ...f.finish.topLeft,
      ...f.finish.bottomRight
    ];
  }
}
class at {
  static create(t, n) {
    return (o, i, e, a, c) => {
      const p = at.triangles(), f = at.vertices(o, i, e, a, c, t, n), R = new C(p, f);
      return R.computeNormals(), R.dress(), R;
    };
  }
  static triangles() {
    return [
      [0, 1, 2],
      [0, 2, 3],
      [4, 5, 6],
      [7, 8, 6],
      [5, 7, 6],
      [5, 9, 10],
      [10, 11, 8],
      [8, 11, 6],
      [9, 11, 10],
      [4, 9, 5],
      [12, 13, 14],
      [12, 14, 15],
      [16, 17, 18],
      [17, 19, 18],
      [20, 21, 22],
      [23, 20, 22],
      [23, 22, 24],
      [25, 26, 27],
      [25, 27, 28],
      [29, 30, 31],
      [30, 32, 31],
      [33, 34, 35],
      [34, 36, 35],
      [36, 37, 35],
      [38, 39, 40],
      [38, 40, 41],
      [42, 43, 44],
      [44, 43, 45],
      [46, 47, 48],
      [49, 46, 48]
    ].flat();
  }
  static vertices(t, n, o, i, e, a, c) {
    const p = new v(
      s.create(-t / 2, -o / 2 + n, i / 2),
      //
      s.create(t / 2, -o / 2 + n, i / 2),
      s.create(-t / 2, o / 2, -i / 2 + e),
      s.create(t / 2, o / 2, -i / 2 + e)
    ), f = new x(p, P.FRONT, a, c), R = new v(
      s.create(-t / 2, -o / 2, i / 2),
      //
      s.create(t / 2, -o / 2, i / 2),
      s.create(-t / 2, -o / 2, -i / 2),
      s.create(t / 2, -o / 2, -i / 2)
    ), L = s.create(-t / 2, o / 2, -i / 2), u = s.create(t / 2, o / 2, -i / 2);
    return [
      ...f.inner.topRight,
      ...f.inner.topLeft,
      ...f.finish.topLeft,
      ...f.finish.topRight,
      ...f.outer.topLeft,
      ...f.inner.topLeft,
      ...f.outer.topRight,
      ...f.inner.topRight,
      ...f.inner.bottomRight,
      ...f.outer.bottomLeft,
      ...f.inner.bottomLeft,
      ...f.outer.bottomRight,
      ...f.outer.bottomLeft,
      ...R.bottomLeft,
      ...R.bottomRight,
      ...f.outer.bottomRight,
      ...R.topLeft,
      ...R.topRight,
      ...R.bottomLeft,
      ...R.bottomRight,
      ...R.bottomLeft,
      ...f.outer.bottomLeft,
      ...f.outer.topLeft,
      ...R.topLeft,
      ...L,
      ...R.topLeft,
      ...L,
      ...u,
      ...R.topRight,
      ...u,
      ...L,
      ...f.outer.topRight,
      ...f.outer.topLeft,
      ...f.outer.bottomRight,
      ...R.bottomRight,
      ...f.outer.topRight,
      ...R.topRight,
      ...u,
      ...f.inner.bottomRight,
      ...f.inner.topRight,
      ...f.finish.topRight,
      ...f.finish.bottomRight,
      ...f.inner.bottomRight,
      ...f.finish.bottomRight,
      ...f.inner.bottomLeft,
      ...f.finish.bottomLeft,
      ...f.finish.topLeft,
      ...f.inner.topLeft,
      ...f.inner.bottomLeft,
      ...f.finish.bottomLeft
    ];
  }
}
class st {
  static create(t, n) {
    return (o, i, e, a, c, p) => {
      const f = st.triangles(), R = st.vertices(o, i, e, a, c, p, t, n), L = new C(f, R);
      return L.computeNormals(), L.dress(), L;
    };
  }
  static triangles() {
    return [
      [0, 1, 2],
      [3, 1, 0],
      [4, 5, 6],
      [5, 7, 6]
    ].flat();
  }
  static vertices(t, n, o, i, e, a, c, p) {
    const f = new v(
      s.create(i / 2, -o / 2 + n, t / 2),
      //
      s.create(-i / 2, -o / 2 + n, t / 2),
      s.create(-i / 2 + a, o / 2, t / 2 - e + a),
      s.create(-i / 2, o / 2, t / 2 - e + a)
    ), R = new x(f, P.RIGHT, c, p), L = new v(
      s.create(-t / 2, -o / 2 + n, i / 2),
      //
      s.create(t / 2, -o / 2 + n, i / 2),
      s.create(-t / 2, o / 2, -i / 2 + a),
      s.create(t / 2 - e + a, o / 2, -i / 2 + a)
    ), u = new x(L, P.FRONT, c, p);
    return [
      ...u.finish.bottomLeft,
      //
      ...u.finish.topRight,
      ...u.finish.topLeft,
      ...u.finish.bottomRight,
      ...R.finish.topRight,
      ...R.finish.topLeft,
      ...R.finish.bottomRight,
      ...R.finish.bottomLeft
    ];
  }
}
class ct {
  static create(t, n) {
    return (o, i, e, a, c, p) => {
      const f = ct.triangles(), R = ct.vertices(o, i, e, a, c, p, t, n), L = new C(f, R);
      return L.computeNormals(), L.dress(), L;
    };
  }
  static triangles() {
    return [
      [0, 1, 2],
      [2, 1, 3],
      [4, 5, 6],
      [6, 7, 8],
      [9, 10, 8],
      [11, 6, 8],
      [10, 11, 8],
      [9, 5, 10],
      [10, 5, 4],
      [5, 7, 6],
      [12, 13, 14],
      [15, 12, 16],
      [15, 17, 18],
      [13, 19, 18],
      [17, 13, 18],
      [16, 17, 15],
      [16, 12, 14],
      [12, 19, 13],
      [20, 21, 22],
      [23, 21, 20],
      [24, 25, 26],
      [24, 26, 27],
      [28, 29, 30],
      [31, 29, 28],
      [32, 33, 34],
      [35, 32, 34],
      [36, 37, 38],
      [38, 37, 39],
      [40, 41, 42],
      [42, 41, 43],
      [44, 45, 46],
      [45, 47, 46],
      [48, 47, 45],
      [49, 50, 51],
      [51, 50, 52],
      [53, 54, 55],
      [56, 53, 55],
      [57, 58, 59],
      [60, 57, 59],
      [61, 62, 63],
      [63, 62, 64],
      [62, 65, 64],
      [66, 67, 68],
      [69, 66, 68],
      [70, 71, 72],
      [73, 70, 72]
    ].flat();
  }
  static vertices(t, n, o, i, e, a, c, p) {
    const f = new v(
      s.create(i / 2, -o / 2 + n, t / 2),
      //
      s.create(-i / 2, -o / 2 + n, t / 2),
      s.create(-i / 2 + a, o / 2, t / 2 - e + a),
      s.create(-i / 2, o / 2, t / 2 - e + a)
    ), R = new x(f, P.RIGHT, c, p), L = new v(
      s.create(-t / 2, -o / 2 + n, i / 2),
      //
      s.create(t / 2, -o / 2 + n, i / 2),
      s.create(-t / 2, o / 2, -i / 2 + a),
      s.create(t / 2 - e + a, o / 2, -i / 2 + a)
    ), u = new x(L, P.FRONT, c, p), m = new v(
      s.create(-t / 2, -o / 2, i / 2),
      //
      s.create(t / 2, -o / 2, i / 2),
      s.create(-t / 2, -o / 2, -i / 2),
      s.create(t / 2, -o / 2, -i / 2)
    ), b = s.create(-t / 2, o / 2, -i / 2);
    return [
      ...u.outer.topRight,
      ...R.outer.topRight,
      ...u.outer.topLeft,
      ...b,
      ...u.inner.bottomLeft,
      ...u.outer.bottomLeft,
      ...u.inner.bottomRight,
      ...u.outer.bottomRight,
      ...u.outer.topRight,
      ...u.outer.topLeft,
      ...u.inner.topLeft,
      ...u.inner.topRight,
      ...u.outer.topRight,
      ...R.inner.bottomLeft,
      ...R.inner.topLeft,
      ...R.outer.topRight,
      ...R.inner.topRight,
      ...R.inner.bottomRight,
      ...R.outer.bottomRight,
      ...u.outer.bottomRight,
      ...u.finish.topLeft,
      ...u.inner.topRight,
      ...u.inner.topLeft,
      ...u.finish.topRight,
      ...u.inner.bottomRight,
      ...u.inner.topRight,
      ...u.finish.topRight,
      ...u.finish.bottomRight,
      ...R.finish.topRight,
      ...R.inner.bottomRight,
      ...R.inner.topRight,
      ...R.finish.bottomRight,
      ...R.inner.topRight,
      ...R.inner.topLeft,
      ...R.finish.topLeft,
      ...R.finish.topRight,
      ...R.inner.topLeft,
      ...R.inner.bottomLeft,
      ...R.finish.topLeft,
      ...R.finish.bottomLeft,
      ...R.outer.bottomRight,
      ...u.outer.bottomRight,
      ...m.topRight,
      ...m.bottomRight,
      ...b,
      ...R.outer.topRight,
      ...m.topLeft,
      ...m.topRight,
      ...R.outer.bottomRight,
      ...u.inner.bottomRight,
      ...u.finish.bottomRight,
      ...u.inner.bottomLeft,
      ...u.finish.bottomLeft,
      ...R.inner.bottomLeft,
      ...R.inner.bottomRight,
      ...R.finish.bottomRight,
      ...R.finish.bottomLeft,
      ...u.finish.topLeft,
      ...u.inner.topLeft,
      ...u.inner.bottomLeft,
      ...u.finish.bottomLeft,
      ...u.outer.bottomLeft,
      ...u.outer.topLeft,
      ...m.bottomLeft,
      ...m.topLeft,
      ...b,
      ...m.bottomRight,
      ...m.bottomLeft,
      ...m.topLeft,
      ...m.topRight,
      ...m.bottomRight,
      ...u.outer.bottomRight,
      ...u.outer.bottomLeft,
      ...m.bottomLeft
    ];
  }
}
class et extends C {
  static create(t, n, o, i, e, a, c) {
    const p = et.triangles(), f = et.vertices(t, n, o, i, e, a, c), R = new C(p, f);
    return R.computeNormals(), R.dress(), R;
  }
  static triangles() {
    return [
      [0, 1, 2],
      [2, 1, 3],
      [4, 5, 6],
      [6, 5, 7],
      [8, 9, 10],
      [10, 9, 11],
      [12, 13, 14],
      [14, 13, 15],
      [16, 17, 18],
      [18, 17, 19],
      [20, 21, 22],
      [22, 21, 23],
      [24, 23, 25],
      [24, 22, 23],
      [26, 27, 28],
      [28, 27, 29],
      [30, 31, 32],
      [32, 31, 33],
      [34, 35, 36],
      [36, 35, 37]
    ].flat();
  }
  static vertices(t, n, o, i, e, a, c) {
    return [
      // Bottom
      [t / 2, -o / 2, i / 2],
      [-t / 2, -o / 2, i / 2],
      [t / 2, -o / 2, -i / 2],
      [-t / 2, -o / 2, -i / 2],
      // Pente avant
      [-(t / 2 - e + c), o / 2, -i / 2 + c],
      [-t / 2, n - o / 2, i / 2],
      [t / 2 - a + c, o / 2, -i / 2 + c],
      [t / 2, n - o / 2, i / 2],
      // Top
      [-(t / 2 - e + c), o / 2, -i / 2 + c],
      [t / 2 - a + c, o / 2, -i / 2 + c],
      [-(t / 2 - e + c), o / 2, -i / 2],
      [t / 2 - a + c, o / 2, -i / 2],
      // Front
      [t / 2, n - o / 2, i / 2],
      [-t / 2, n - o / 2, i / 2],
      [t / 2, -o / 2, i / 2],
      [-t / 2, -o / 2, i / 2],
      // Right
      [t / 2, n - o / 2, -i / 2],
      [t / 2, n - o / 2, i / 2],
      [t / 2, -o / 2, -i / 2],
      [t / 2, -o / 2, i / 2],
      // Back
      [-t / 2, n - o / 2, -i / 2],
      [-(t / 2 - e + c), o / 2, -i / 2],
      [-t / 2, -o / 2, -i / 2],
      [t / 2 - a + c, o / 2, -i / 2],
      [t / 2, -o / 2, -i / 2],
      [t / 2, n - o / 2, -i / 2],
      // Left
      [-t / 2, n - o / 2, i / 2],
      [-t / 2, n - o / 2, -i / 2],
      [-t / 2, -o / 2, i / 2],
      [-t / 2, -o / 2, -i / 2],
      // Pente droite
      [t / 2 - a + c, o / 2, -i / 2],
      [t / 2 - a + c, o / 2, -i / 2 + c],
      [t / 2, n - o / 2, -i / 2],
      [t / 2, n - o / 2, i / 2],
      // Pente gauche
      [-t / 2, n - o / 2, i / 2],
      [-(t / 2 - e + c), o / 2, -i / 2 + c],
      [-t / 2, n - o / 2, -i / 2],
      [-(t / 2 - e + c), o / 2, -i / 2]
    ].flat();
  }
}
class ft {
  static create(t, n, o, i, e, a) {
    const c = ft.triangles(), p = ft.vertices(t, n, o, i, e, a), f = new C(c, p);
    return f.computeNormals(), f.dress(), f;
  }
  static triangles() {
    return [
      [0, 1, 2],
      [2, 1, 3],
      [4, 5, 6],
      [6, 5, 7],
      [8, 9, 10],
      [10, 9, 11],
      [11, 9, 12],
      [13, 14, 15],
      [15, 14, 16],
      [16, 14, 17],
      [18, 19, 20],
      [20, 19, 21],
      [22, 23, 24],
      [24, 23, 25],
      [26, 27, 28],
      [28, 27, 29],
      [30, 31, 32],
      [32, 31, 33]
    ].flat();
  }
  static vertices(t, n, o, i, e, a) {
    return [
      // Pente gauche
      [-(t / 2 - e + a), o / 2, -i / 2],
      [-t / 2, n - o / 2, -i / 2],
      [-(t / 2 - e + a), o / 2, -i / 2 + a],
      [-t / 2, n - o / 2, i / 2],
      // Pente avant
      [t / 2, o / 2, -i / 2 + a],
      [-(t / 2 - e + a), o / 2, -i / 2 + a],
      [t / 2, n - o / 2, i / 2],
      [-t / 2, n - o / 2, i / 2],
      // Right
      [t / 2, o / 2, -i / 2],
      [t / 2, o / 2, -i / 2 + a],
      [t / 2, -o / 2, -i / 2],
      [t / 2, -o / 2, i / 2],
      [t / 2, n - o / 2, i / 2],
      // Back
      [-t / 2, n - o / 2, -i / 2],
      [-(t / 2 - e + a), o / 2, -i / 2],
      [-t / 2, -o / 2, -i / 2],
      [t / 2, -o / 2, -i / 2],
      [t / 2, o / 2, -i / 2],
      // Left
      [-t / 2, n - o / 2, i / 2],
      [-t / 2, n - o / 2, -i / 2],
      [-t / 2, -o / 2, i / 2],
      [-t / 2, -o / 2, -i / 2],
      // Front
      [t / 2, n - o / 2, i / 2],
      [-t / 2, n - o / 2, i / 2],
      [t / 2, -o / 2, i / 2],
      [-t / 2, -o / 2, i / 2],
      // Bottom
      [t / 2, -o / 2, -i / 2],
      [t / 2, -o / 2, i / 2],
      [-t / 2, -o / 2, -i / 2],
      [-t / 2, -o / 2, i / 2],
      // Top
      [-(t / 2 - e + a), o / 2, -i / 2],
      [-(t / 2 - e + a), o / 2, -i / 2 + a],
      [t / 2, o / 2, -i / 2],
      [t / 2, o / 2, -i / 2 + a]
    ].flat();
  }
}
class ut {
  static create(t, n, o, i, e) {
    const a = ut.triangles(), c = ut.vertices(t, n, o, i, e), p = new C(a, c);
    return p.computeNormals(), p.dress(), p;
  }
  static triangles() {
    return [
      [0, 1, 2],
      [2, 1, 3],
      [3, 1, 4],
      [5, 6, 7],
      [7, 6, 8],
      [9, 7, 8],
      [10, 11, 12],
      [12, 11, 13],
      [14, 15, 16],
      [16, 15, 17],
      [18, 19, 20],
      [20, 19, 21],
      [22, 23, 24],
      [24, 23, 25],
      [26, 27, 28],
      [28, 27, 29]
    ].flat();
  }
  static vertices(t, n, o, i, e) {
    return [
      // Left
      [-t / 2, n - o / 2, i / 2],
      [-t / 2, o / 2, -i / 2 + e],
      [-t / 2, -o / 2, i / 2],
      [-t / 2, -o / 2, -i / 2],
      [-t / 2, o / 2, -i / 2],
      // Right
      [t / 2, n - o / 2, i / 2],
      [t / 2, -o / 2, i / 2],
      [t / 2, o / 2, -i / 2 + e],
      [t / 2, -o / 2, -i / 2],
      [t / 2, o / 2, -i / 2],
      // Pente avant
      [t / 2, n - o / 2, i / 2],
      [t / 2, o / 2, -i / 2 + e],
      [-t / 2, n - o / 2, i / 2],
      [-t / 2, o / 2, -i / 2 + e],
      // Back
      [-t / 2, o / 2, -i / 2],
      [t / 2, o / 2, -i / 2],
      [-t / 2, -o / 2, -i / 2],
      [t / 2, -o / 2, -i / 2],
      // Front
      [-t / 2, -o / 2, i / 2],
      [t / 2, -o / 2, i / 2],
      [-t / 2, n - o / 2, i / 2],
      [t / 2, n - o / 2, i / 2],
      // Top
      [t / 2, o / 2, -i / 2],
      [-t / 2, o / 2, -i / 2],
      [t / 2, o / 2, -i / 2 + e],
      [-t / 2, o / 2, -i / 2 + e],
      // Bottom
      [-t / 2, -o / 2, -i / 2],
      [t / 2, -o / 2, -i / 2],
      [-t / 2, -o / 2, i / 2],
      [t / 2, -o / 2, i / 2]
    ].flat();
  }
}
class pt {
  static create(t, n, o, i, e, a) {
    const c = pt.triangles(), p = pt.vertices(t, n, o, i, e, a), f = new C(c, p);
    return f.computeNormals(), f.dress(), f;
  }
  static triangles() {
    return [
      [0, 1, 2],
      [2, 1, 3],
      [4, 5, 6],
      [6, 5, 7],
      [8, 9, 10],
      [10, 9, 11],
      [11, 9, 12],
      [13, 14, 15],
      [15, 14, 16],
      [16, 14, 17],
      [18, 19, 20],
      [20, 19, 21],
      [22, 23, 24],
      [24, 23, 25],
      [26, 27, 28],
      [28, 27, 29],
      [30, 31, 32],
      [32, 31, 33]
    ].flat();
  }
  static vertices(t, n, o, i, e, a) {
    return [
      // Top
      [t / 2 - e + a, o / 2, -i / 2 + a],
      [t / 2 - e + a, o / 2, -i / 2],
      [-t / 2, o / 2, -i / 2 + a],
      [-t / 2, o / 2, -i / 2],
      // Bottom
      [-t / 2, -o / 2, i / 2],
      [-t / 2, -o / 2, -i / 2],
      [t / 2, -o / 2, i / 2],
      [t / 2, -o / 2, -i / 2],
      // Back
      [-t / 2, o / 2, -i / 2],
      [t / 2 - e + a, o / 2, -i / 2],
      [-t / 2, -o / 2, -i / 2],
      [t / 2, -o / 2, -i / 2],
      [t / 2, n - o / 2, -i / 2],
      // Left
      [-t / 2, n - o / 2, i / 2],
      [-t / 2, o / 2, -i / 2 + a],
      [-t / 2, -o / 2, i / 2],
      [-t / 2, -o / 2, -i / 2],
      [-t / 2, o / 2, -i / 2],
      // Front
      [t / 2, n - o / 2, i / 2],
      [-t / 2, n - o / 2, i / 2],
      [t / 2, -o / 2, i / 2],
      [-t / 2, -o / 2, i / 2],
      // Right
      [t / 2, n - o / 2, -i / 2],
      [t / 2, n - o / 2, i / 2],
      [t / 2, -o / 2, -i / 2],
      [t / 2, -o / 2, i / 2],
      // Pente droite
      [t / 2 - e + a, o / 2, -i / 2],
      [t / 2 - e + a, o / 2, -i / 2 + a],
      [t / 2, n - o / 2, -i / 2],
      [t / 2, n - o / 2, i / 2],
      // Pente avant
      [t / 2, n - o / 2, i / 2],
      [t / 2 - e + a, o / 2, -i / 2 + a],
      [-t / 2, n - o / 2, i / 2],
      [-t / 2, o / 2, -i / 2 + a]
    ].flat();
  }
}
const Bo = {
  noCapsMesh: ut.create,
  leftCapMesh: ft.create,
  rightCapMesh: pt.create,
  bothCapsMesh: et.create
};
class Rt {
  static create(t, n) {
    return (o, i, e, a, c, p) => {
      const f = Rt.triangles(), R = Rt.vertices(o, i, e, a, c, p, t, n), L = new C(f, R);
      return L.computeNormals(), L.dress(), L;
    };
  }
  static triangles() {
    return [
      [0, 1, 2],
      [1, 3, 2],
      [4, 5, 6],
      [6, 5, 7],
      [8, 9, 10],
      [11, 8, 10]
    ].flat();
  }
  static vertices(t, n, o, i, e, a, c, p) {
    const f = new v(
      s.create(-o / 2, n / 2, -t / 2),
      //
      s.create(o / 2, n / 2, -t / 2),
      s.create(-o / 2, n / 2, -(t / 2 - i + a)),
      s.create(-o / 2 + a, n / 2, -(t / 2 - i + a))
    ), R = new x(f, P.LEFT, c, p), L = new v(
      s.create(o / 2, n / 2, t / 2),
      //
      s.create(-o / 2, n / 2, t / 2),
      s.create(-o / 2 + a, n / 2, t / 2 - e + a),
      s.create(-o / 2, n / 2, t / 2 - e + a)
    ), u = new x(L, P.RIGHT, c, p), m = new v(
      s.create(-t / 2, n / 2, o / 2),
      //
      s.create(t / 2, n / 2, o / 2),
      s.create(-(t / 2 - i + a), n / 2, -o / 2 + a),
      s.create(t / 2 - e + a, n / 2, -o / 2 + a)
    ), b = new x(m, P.FRONT, c, p);
    return [
      ...R.finish.bottomRight,
      //
      ...R.finish.topRight,
      ...R.finish.bottomLeft,
      ...R.finish.topLeft,
      ...b.finish.bottomLeft,
      ...b.finish.bottomRight,
      ...b.finish.topLeft,
      ...b.finish.topRight,
      ...u.finish.topLeft,
      ...u.finish.bottomLeft,
      ...u.finish.bottomRight,
      ...u.finish.topRight
    ];
  }
}
class Lt {
  static create(t, n) {
    return (o, i, e, a, c, p) => {
      const f = Lt.triangles(), R = Lt.vertices(o, i, e, a, c, p, t, n), L = new C(f, R);
      return L.computeNormals(), L.dress(), L;
    };
  }
  static triangles() {
    return [
      [0, 1, 2],
      [3, 1, 0],
      [4, 5, 6],
      [7, 4, 6],
      [8, 9, 10],
      [9, 11, 10],
      [12, 13, 14],
      [12, 15, 13],
      [16, 17, 18],
      [18, 17, 19],
      [20, 21, 22],
      [23, 20, 22],
      [24, 25, 26],
      [27, 25, 24],
      [28, 29, 30],
      [31, 29, 28],
      [32, 33, 34],
      [35, 32, 34],
      [36, 37, 38],
      [39, 36, 40],
      [41, 42, 36],
      [42, 41, 43],
      [41, 36, 39],
      [36, 38, 40],
      [38, 43, 44],
      [43, 41, 45],
      [46, 41, 39],
      [46, 47, 48],
      [46, 39, 47],
      [49, 39, 40],
      [49, 40, 48],
      [48, 40, 50],
      [46, 48, 51],
      [44, 45, 51],
      [44, 43, 45],
      [38, 37, 43],
      [50, 44, 51],
      [48, 50, 51],
      [52, 53, 54],
      [52, 55, 53],
      [56, 57, 58],
      [58, 57, 59],
      [60, 61, 62],
      [62, 61, 63],
      [64, 65, 66],
      [66, 65, 67],
      [68, 69, 70],
      [71, 68, 70],
      [72, 73, 74],
      [72, 74, 75],
      [76, 77, 78],
      [78, 77, 79],
      [80, 81, 82],
      [81, 83, 82]
    ].flat();
  }
  static vertices(t, n, o, i, e, a, c, p) {
    const f = new v(
      s.create(-o / 2, n / 2, -t / 2),
      //
      s.create(o / 2, n / 2, -t / 2),
      s.create(-o / 2, n / 2, -(t / 2 - i + a)),
      s.create(-o / 2 + a, n / 2, -(t / 2 - i + a))
    ), R = new x(f, P.LEFT, c, p), L = new v(
      s.create(o / 2, n / 2, t / 2),
      //
      s.create(-o / 2, n / 2, t / 2),
      s.create(-o / 2 + a, n / 2, t / 2 - e + a),
      s.create(-o / 2, n / 2, t / 2 - e + a)
    ), u = new x(L, P.RIGHT, c, p), m = new v(
      s.create(-t / 2, n / 2, o / 2),
      //
      s.create(t / 2, n / 2, o / 2),
      s.create(-(t / 2 - i + a), n / 2, -o / 2 + a),
      s.create(t / 2 - e + a, n / 2, -o / 2 + a)
    ), b = new x(m, P.FRONT, c, p), l = new v(
      s.create(-t / 2, -n / 2, o / 2),
      //
      s.create(t / 2, -n / 2, o / 2),
      s.create(-t / 2, -n / 2, -o / 2),
      s.create(t / 2, -n / 2, -o / 2)
    );
    return [
      ...R.inner.topRight,
      ...R.finish.bottomRight,
      ...R.inner.bottomRight,
      ...R.finish.topRight,
      ...u.outer.bottomRight,
      ...l.topRight,
      ...l.topLeft,
      ...R.outer.bottomLeft,
      ...l.topLeft,
      ...l.bottomLeft,
      ...R.outer.bottomLeft,
      ...R.outer.bottomRight,
      ...l.bottomLeft,
      ...l.topRight,
      ...l.bottomRight,
      ...l.topLeft,
      ...u.inner.topRight,
      ...u.inner.topLeft,
      ...u.finish.topRight,
      ...u.finish.topLeft,
      ...b.finish.topLeft,
      ...b.inner.topLeft,
      ...b.inner.bottomLeft,
      ...b.finish.bottomLeft,
      ...l.bottomRight,
      ...R.outer.bottomRight,
      ...l.bottomLeft,
      ...u.outer.bottomLeft,
      ...l.topRight,
      ...u.outer.bottomLeft,
      ...l.bottomRight,
      ...u.outer.bottomRight,
      ...b.finish.topRight,
      ...b.inner.topRight,
      ...b.inner.topLeft,
      ...b.finish.topLeft,
      ...R.inner.topLeft,
      ...R.inner.topRight,
      ...b.inner.topLeft,
      ...u.inner.topRight,
      ...b.inner.topRight,
      ...R.outer.bottomLeft,
      ...R.inner.bottomLeft,
      ...R.inner.bottomRight,
      ...b.inner.bottomLeft,
      ...R.outer.bottomRight,
      ...u.outer.bottomRight,
      ...u.inner.bottomRight,
      ...u.inner.bottomLeft,
      ...u.inner.topLeft,
      ...b.inner.bottomRight,
      ...u.outer.bottomLeft,
      ...b.inner.topRight,
      ...b.finish.bottomRight,
      ...b.inner.bottomRight,
      ...b.finish.topRight,
      ...u.inner.bottomRight,
      ...u.inner.topRight,
      ...u.finish.bottomRight,
      ...u.finish.topRight,
      ...u.inner.bottomLeft,
      ...u.inner.bottomRight,
      ...u.finish.bottomLeft,
      ...u.finish.bottomRight,
      ...R.inner.bottomLeft,
      ...R.inner.bottomRight,
      ...R.finish.bottomLeft,
      ...R.finish.bottomRight,
      ...R.finish.topLeft,
      ...R.inner.topLeft,
      ...R.inner.bottomLeft,
      ...R.finish.bottomLeft,
      ...b.finish.bottomLeft,
      ...b.inner.bottomLeft,
      ...b.inner.bottomRight,
      ...b.finish.bottomRight,
      ...R.inner.topRight,
      ...R.inner.topLeft,
      ...R.finish.topRight,
      ...R.finish.topLeft,
      ...u.inner.topLeft,
      ...u.inner.bottomLeft,
      ...u.finish.topLeft,
      ...u.finish.bottomLeft
    ];
  }
}
class mt {
  static create(t, n) {
    return (o, i, e, a, c) => {
      const p = mt.triangles(), f = mt.vertices(o, i, e, a, c, t, n), R = new C(p, f);
      return R.computeNormals(), R.dress(), R;
    };
  }
  static triangles() {
    return [
      [0, 1, 2],
      [0, 2, 3],
      [4, 5, 6],
      [4, 6, 7]
    ].flat();
  }
  static vertices(t, n, o, i, e, a, c) {
    const p = new v(
      s.create(-o / 2, n / 2, -t / 2),
      //
      s.create(o / 2, n / 2, -t / 2),
      s.create(-o / 2, n / 2, -(t / 2 - i + e)),
      s.create(-o / 2 + e, n / 2, -(t / 2 - i + e))
    ), f = new x(p, P.LEFT, a, c), R = new v(
      s.create(-t / 2, n / 2, o / 2),
      //
      s.create(t / 2, n / 2, o / 2),
      s.create(-(t / 2 - i + e), n / 2, -o / 2 + e),
      s.create(t / 2, n / 2, -o / 2 + e)
    ), L = new x(R, P.FRONT, a, c);
    return [
      ...L.finish.bottomRight,
      //
      ...L.finish.topRight,
      ...L.finish.topLeft,
      ...L.finish.bottomLeft,
      ...f.finish.bottomLeft,
      ...f.finish.bottomRight,
      ...f.finish.topRight,
      ...f.finish.topLeft
    ].flat();
  }
}
class bt {
  static create(t, n) {
    return (o, i, e, a, c) => {
      const p = bt.triangles(), f = bt.vertices(o, i, e, a, c, t, n), R = new C(p, f);
      return R.computeNormals(), R.dress(), R;
    };
  }
  static triangles() {
    return [
      [0, 1, 2],
      [3, 1, 0],
      [4, 5, 6],
      [7, 4, 6],
      [8, 9, 10],
      [8, 10, 11],
      [12, 13, 14],
      [15, 14, 16],
      [13, 16, 14],
      [15, 17, 14],
      [18, 17, 19],
      [19, 15, 20],
      [21, 20, 13],
      [12, 21, 13],
      [22, 23, 21],
      [21, 19, 20],
      [19, 17, 15],
      [22, 17, 18],
      [22, 18, 23],
      [22, 21, 12],
      [24, 25, 26],
      [27, 25, 24],
      [28, 29, 30],
      [31, 28, 30],
      [32, 33, 34],
      [32, 35, 33],
      [36, 37, 38],
      [38, 37, 39],
      [40, 41, 42],
      [43, 41, 40],
      [44, 45, 46],
      [46, 45, 47],
      [48, 49, 50],
      [50, 49, 51],
      [52, 53, 54],
      [53, 55, 54],
      [56, 57, 58],
      [58, 57, 59],
      [60, 61, 62],
      [63, 60, 62]
    ].flat();
  }
  static vertices(t, n, o, i, e, a, c) {
    const p = new v(
      s.create(-o / 2, n / 2, -t / 2),
      //
      s.create(o / 2, n / 2, -t / 2),
      s.create(-o / 2, n / 2, -(t / 2 - i + e)),
      s.create(-o / 2 + e, n / 2, -(t / 2 - i + e))
    ), f = new x(p, P.LEFT, a, c), R = new v(
      s.create(-t / 2, n / 2, o / 2),
      //
      s.create(t / 2, n / 2, o / 2),
      s.create(-(t / 2 - i + e), n / 2, -o / 2 + e),
      s.create(t / 2, n / 2, -o / 2 + e)
    ), L = new x(R, P.FRONT, a, c), u = new v(
      s.create(-t / 2, -n / 2, o / 2),
      //
      s.create(t / 2, -n / 2, o / 2),
      s.create(-t / 2, -n / 2, -o / 2),
      s.create(t / 2, -n / 2, -o / 2)
    ), m = s.create(t / 2, n / 2, -o / 2);
    return [
      ...u.bottomRight,
      ...u.topLeft,
      ...u.topRight,
      ...u.bottomLeft,
      ...L.finish.topLeft,
      ...L.inner.topLeft,
      ...L.inner.bottomLeft,
      ...L.finish.bottomLeft,
      ...f.outer.bottomRight,
      ...u.bottomLeft,
      ...u.bottomRight,
      ...L.outer.bottomRight,
      ...f.outer.bottomRight,
      ...f.inner.bottomRight,
      ...f.outer.bottomLeft,
      ...f.inner.topLeft,
      ...f.inner.bottomLeft,
      ...m,
      ...L.inner.topRight,
      ...L.inner.topLeft,
      ...f.inner.topRight,
      ...L.inner.bottomLeft,
      ...L.outer.bottomRight,
      ...L.inner.bottomRight,
      ...u.topRight,
      ...L.outer.bottomRight,
      ...u.bottomRight,
      ...m,
      ...L.finish.topRight,
      ...L.inner.topRight,
      ...L.inner.topLeft,
      ...L.finish.topLeft,
      ...f.inner.bottomRight,
      ...f.finish.bottomLeft,
      ...f.inner.bottomLeft,
      ...f.finish.bottomRight,
      ...f.inner.topLeft,
      ...f.inner.bottomLeft,
      ...f.finish.topLeft,
      ...f.finish.bottomLeft,
      ...u.bottomLeft,
      ...f.outer.bottomLeft,
      ...u.topLeft,
      ...f.outer.bottomRight,
      ...f.inner.bottomRight,
      ...f.inner.topRight,
      ...f.finish.bottomRight,
      ...f.finish.topRight,
      ...f.inner.topRight,
      ...f.inner.topLeft,
      ...f.finish.topRight,
      ...f.finish.topLeft,
      ...L.inner.bottomLeft,
      ...L.inner.bottomRight,
      ...L.finish.bottomLeft,
      ...L.finish.bottomRight,
      ...L.inner.bottomRight,
      ...L.inner.topRight,
      ...L.finish.bottomRight,
      ...L.finish.topRight,
      ...m,
      ...u.topRight,
      ...u.topLeft,
      ...f.outer.bottomLeft
    ].flat();
  }
}
class lt {
  static create(t, n) {
    return (o, i, e, a) => {
      const c = lt.triangles(), p = lt.vertices(o, i, e, a, t, n), f = new C(c, p);
      return f.computeNormals(), f.dress(), f;
    };
  }
  static triangles() {
    return [
      [0, 1, 2],
      [0, 2, 3]
    ].flat();
  }
  static vertices(t, n, o, i, e, a) {
    const c = new v(
      s.create(-t / 2, n / 2, o / 2),
      //
      s.create(t / 2, n / 2, o / 2),
      s.create(-t / 2, n / 2, -o / 2 + i),
      s.create(t / 2, n / 2, -o / 2 + i)
    ), p = new x(c, P.FRONT, e, a);
    return [
      ...p.finish.bottomRight,
      //
      ...p.finish.topRight,
      ...p.finish.topLeft,
      ...p.finish.bottomLeft
    ];
  }
}
class gt {
  static create(t, n) {
    return (o, i, e, a) => {
      const c = gt.triangles(), p = gt.vertices(o, i, e, a, t, n), f = new C(c, p);
      return f.computeNormals(), f.dress(), f;
    };
  }
  static triangles() {
    return [
      [0, 1, 2],
      [2, 1, 3],
      [4, 5, 6],
      [7, 5, 4],
      [8, 9, 10],
      [8, 10, 11],
      [12, 13, 14],
      [12, 14, 15],
      [16, 17, 18],
      [19, 17, 16],
      [20, 21, 22],
      [20, 23, 21],
      [24, 25, 26],
      [26, 27, 28],
      [29, 30, 28],
      [24, 31, 30],
      [24, 26, 31],
      [26, 25, 27],
      [29, 28, 27],
      [24, 30, 29],
      [32, 33, 34],
      [33, 35, 34],
      [36, 37, 38],
      [38, 37, 39],
      [40, 41, 42],
      [43, 40, 42]
    ].flat();
  }
  static vertices(t, n, o, i, e, a) {
    const c = new v(
      s.create(-t / 2, n / 2, o / 2),
      //
      s.create(t / 2, n / 2, o / 2),
      s.create(-t / 2, n / 2, -o / 2 + i),
      s.create(t / 2, n / 2, -o / 2 + i)
    ), p = new x(c, P.FRONT, e, a), f = new v(
      s.create(-t / 2, -n / 2, o / 2),
      //
      s.create(t / 2, -n / 2, o / 2),
      s.create(-t / 2, -n / 2, -o / 2),
      s.create(t / 2, -n / 2, -o / 2)
    ), R = s.create(-t / 2, n / 2, -o / 2), L = s.create(t / 2, n / 2, -o / 2);
    return [
      ...p.inner.topRight,
      ...p.inner.topLeft,
      ...p.finish.topRight,
      ...p.finish.topLeft,
      ...f.bottomLeft,
      ...R,
      ...f.topLeft,
      ...p.outer.bottomLeft,
      ...p.outer.bottomLeft,
      ...f.bottomLeft,
      ...f.bottomRight,
      ...p.outer.bottomRight,
      ...f.bottomLeft,
      ...f.topLeft,
      ...f.topRight,
      ...f.bottomRight,
      ...f.topRight,
      ...p.outer.bottomRight,
      ...f.bottomRight,
      ...L,
      ...f.topLeft,
      ...L,
      ...f.topRight,
      ...R,
      ...p.outer.bottomRight,
      ...L,
      ...p.inner.topRight,
      ...R,
      ...p.inner.topLeft,
      ...p.outer.bottomLeft,
      ...p.inner.bottomLeft,
      ...p.inner.bottomRight,
      ...p.inner.bottomLeft,
      ...p.inner.bottomRight,
      ...p.finish.bottomLeft,
      ...p.finish.bottomRight,
      ...p.inner.topLeft,
      ...p.inner.bottomLeft,
      ...p.finish.topLeft,
      ...p.finish.bottomLeft,
      ...p.finish.bottomRight,
      ...p.inner.bottomRight,
      ...p.inner.topRight,
      ...p.finish.topRight
    ];
  }
}
class vt {
  static create(t, n) {
    return (o, i, e, a, c) => {
      const p = vt.triangles(), f = vt.vertices(o, i, e, a, c, t, n), R = new C(p, f);
      return R.computeNormals(), R.dress(), R;
    };
  }
  static triangles() {
    return [
      [0, 1, 2],
      [3, 1, 0],
      [4, 5, 6],
      [7, 4, 6]
    ].flat();
  }
  static vertices(t, n, o, i, e, a, c) {
    const p = new v(
      s.create(o / 2, n / 2, t / 2),
      //
      s.create(-o / 2, n / 2, t / 2),
      s.create(-o / 2 + e, n / 2, t / 2 - i + e),
      s.create(-o / 2, n / 2, t / 2 - i + e)
    ), f = new x(p, P.RIGHT, a, c), R = new v(
      s.create(-t / 2, n / 2, o / 2),
      //
      s.create(t / 2, n / 2, o / 2),
      s.create(-t / 2, n / 2, -o / 2 + e),
      s.create(t / 2 - i + e, n / 2, -o / 2 + e)
    ), L = new x(R, P.FRONT, a, c);
    return [
      ...L.finish.bottomLeft,
      //
      ...L.finish.topRight,
      ...L.finish.topLeft,
      ...L.finish.bottomRight,
      ...f.finish.topLeft,
      ...f.finish.bottomLeft,
      ...f.finish.bottomRight,
      ...f.finish.topRight
    ];
  }
}
class Mt {
  static create(t, n) {
    return (o, i, e, a, c) => {
      const p = Mt.triangles(), f = Mt.vertices(o, i, e, a, c, t, n), R = new C(p, f);
      return R.computeNormals(), R.dress(), R;
    };
  }
  static triangles() {
    return [
      [0, 1, 2],
      [0, 2, 3],
      [4, 5, 6],
      [5, 7, 6],
      [8, 9, 10],
      [8, 11, 9],
      [12, 13, 14],
      [14, 13, 15],
      [16, 17, 18],
      [19, 16, 18],
      [20, 21, 22],
      [23, 21, 24],
      [22, 21, 25],
      [20, 22, 26],
      [27, 22, 25],
      [28, 27, 29],
      [20, 28, 30],
      [20, 26, 28],
      [28, 29, 30],
      [27, 25, 29],
      [21, 23, 25],
      [31, 23, 24],
      [29, 31, 24],
      [29, 24, 30],
      [32, 33, 34],
      [32, 35, 33],
      [36, 37, 38],
      [36, 39, 37],
      [40, 41, 42],
      [43, 40, 42],
      [44, 45, 46],
      [44, 46, 47],
      [48, 49, 50],
      [50, 49, 51],
      [52, 53, 54],
      [54, 53, 55],
      [56, 57, 58],
      [58, 57, 59],
      [60, 61, 62],
      [63, 61, 60]
    ].flat();
  }
  static vertices(t, n, o, i, e, a, c) {
    const p = new v(
      s.create(o / 2, n / 2, t / 2),
      //
      s.create(-o / 2, n / 2, t / 2),
      s.create(-o / 2 + e, n / 2, t / 2 - i + e),
      s.create(-o / 2, n / 2, t / 2 - i + e)
    ), f = new x(p, P.RIGHT, a, c), R = new v(
      s.create(-t / 2, n / 2, o / 2),
      //
      s.create(t / 2, n / 2, o / 2),
      s.create(-t / 2, n / 2, -o / 2 + e),
      s.create(t / 2 - i + e, n / 2, -o / 2 + e)
    ), L = new x(R, P.FRONT, a, c), u = new v(
      s.create(-t / 2, -n / 2, o / 2),
      //
      s.create(t / 2, -n / 2, o / 2),
      s.create(-t / 2, -n / 2, -o / 2),
      s.create(t / 2, -n / 2, -o / 2)
    ), m = s.create(-t / 2, n / 2, -o / 2);
    return [
      ...m,
      ...u.topLeft,
      ...u.bottomLeft,
      ...L.outer.bottomLeft,
      ...L.inner.bottomLeft,
      ...L.inner.bottomRight,
      ...L.finish.bottomLeft,
      ...L.finish.bottomRight,
      ...u.topLeft,
      ...u.bottomRight,
      ...u.bottomLeft,
      ...u.topRight,
      ...u.topRight,
      ...u.topLeft,
      ...f.outer.bottomRight,
      ...m,
      ...L.finish.topRight,
      ...L.inner.topRight,
      ...L.inner.topLeft,
      ...L.finish.topLeft,
      ...f.outer.bottomRight,
      ...m,
      ...f.inner.topRight,
      ...L.inner.topLeft,
      ...L.outer.bottomLeft,
      ...L.inner.topRight,
      ...f.inner.bottomRight,
      ...f.inner.topLeft,
      ...f.inner.bottomLeft,
      ...L.inner.bottomRight,
      ...f.outer.bottomLeft,
      ...L.inner.bottomLeft,
      ...L.inner.topRight,
      ...L.finish.bottomRight,
      ...L.inner.bottomRight,
      ...L.finish.topRight,
      ...f.inner.topRight,
      ...f.finish.bottomRight,
      ...f.inner.bottomRight,
      ...f.finish.topRight,
      ...f.finish.bottomLeft,
      ...f.inner.bottomLeft,
      ...f.inner.bottomRight,
      ...f.finish.bottomRight,
      ...L.outer.bottomLeft,
      ...u.bottomLeft,
      ...u.bottomRight,
      ...f.outer.bottomLeft,
      ...L.inner.topLeft,
      ...L.inner.bottomLeft,
      ...L.finish.topLeft,
      ...L.finish.bottomLeft,
      ...f.inner.topRight,
      ...f.inner.topLeft,
      ...f.finish.topRight,
      ...f.finish.topLeft,
      ...f.inner.topLeft,
      ...f.inner.bottomLeft,
      ...f.finish.topLeft,
      ...f.finish.bottomLeft,
      ...u.topRight,
      ...f.outer.bottomLeft,
      ...u.bottomRight,
      ...f.outer.bottomRight
    ];
  }
}
class Pt {
  static create(t, n, o) {
    const i = Pt.triangles(), e = Pt.vertices(t, n, o), a = new C(i, e);
    return a.computeNormals(), a.dress(), a;
  }
  static triangles() {
    return [
      [0, 1, 2],
      [3, 1, 0],
      [4, 5, 6],
      [4, 7, 5],
      [8, 9, 10],
      [8, 11, 9],
      [12, 13, 14],
      [15, 13, 12],
      [16, 17, 18],
      [19, 17, 16],
      [20, 21, 22],
      [20, 23, 21]
    ].flat();
  }
  static vertices(t, n, o) {
    return [
      // Front
      [t / 2, -n / 2, o / 2],
      [-t / 2, n / 2, o / 2],
      [-t / 2, -n / 2, o / 2],
      [t / 2, n / 2, o / 2],
      // Back
      [t / 2, -n / 2, -o / 2],
      [-t / 2, n / 2, -o / 2],
      [t / 2, n / 2, -o / 2],
      [-t / 2, -n / 2, -o / 2],
      // Left
      [-t / 2, n / 2, -o / 2],
      [-t / 2, -n / 2, o / 2],
      [-t / 2, n / 2, o / 2],
      [-t / 2, -n / 2, -o / 2],
      // Right
      [t / 2, n / 2, -o / 2],
      [t / 2, -n / 2, o / 2],
      [t / 2, -n / 2, -o / 2],
      [t / 2, n / 2, o / 2],
      // Top
      [-t / 2, n / 2, o / 2],
      [t / 2, n / 2, -o / 2],
      [-t / 2, n / 2, -o / 2],
      [t / 2, n / 2, o / 2],
      // Bottom
      [-t / 2, -n / 2, o / 2],
      [t / 2, -n / 2, -o / 2],
      [t / 2, -n / 2, o / 2],
      [-t / 2, -n / 2, -o / 2]
    ].flat();
  }
}
const k = 2, y = 1;
function bo(r) {
  return Array.isArray(r.height) ? Math.max(...r.height) / 100 : r.height / 100;
}
function Zo(r) {
  const t = bo(r) / 2;
  return H.initPoints(
    [
      -r.overall.width / 100 / 2,
      //
      0,
      -r.overall.depth / 100 / 2
    ],
    [
      r.overall.width / 100 / 2,
      //
      t,
      r.overall.depth / 100 / 2
    ]
  );
}
function Oo(r) {
  return ((r.overall.depth - r.recette.depth) / 2 - r.frontView) / 100;
}
function ho(r) {
  return ((r.overall.width - r.recette.width) / 2 - r.leftView) / 100;
}
function Ao(r) {
  return Object.entries(r.parts).map(([t, n]) => {
    const o = Go(t, n, r), i = qo(t, n, r), e = wo(t, n, r).map((c) => W(c)), a = Yo(t).map((c) => W(c));
    return {
      database: r.database,
      configuration: o,
      materials: [{ tag: t.toUpperCase() }],
      surfaces: i,
      translation: {
        x: e[0],
        y: e[1],
        z: e[2]
      },
      rotation: {
        x: a[0],
        y: a[1],
        z: a[2]
      }
    };
  });
}
function Go(r, t, n) {
  const o = Array.isArray(n.height), i = !!n.hammered;
  return [
    `TYPE.${o ? "BEVELLED" : "FLAT"}`,
    //
    `FINISH.${i ? "HAMMERED" : "POLISHED"}`,
    `ASSEMBLY.${n.assemblyType}`,
    `PART.${r.toUpperCase()}`
  ].join("/");
}
function qo(r, t, n) {
  const o = Array.isArray(n.height), i = !!n.hammered;
  return o ? i ? Ko(r, t, n) : Uo(r, t, n) : i ? Vo(r, t, n) : Ho(r, t, n);
}
function Ho(r, t, n) {
  const o = Pt.create(t.width / 100, n.height / 100, t.depth / 100);
  return [
    X(o, r.toUpperCase())
    //
  ];
}
function Vo(r, t, n) {
  const o = po(r, t, n, {
    noCapsMesh: gt.create(k / 100, y / 100),
    leftCapMesh: bt.create(k / 100, y / 100),
    rightCapMesh: Mt.create(k / 100, y / 100),
    bothCapsMesh: Lt.create(k / 100, y / 100)
  }), i = po(r, t, n, {
    noCapsMesh: lt.create(k / 100, y / 100),
    leftCapMesh: mt.create(k / 100, y / 100),
    rightCapMesh: vt.create(k / 100, y / 100),
    bothCapsMesh: Rt.create(k / 100, y / 100)
  });
  return [
    X(o, r.toUpperCase()),
    //
    X(i, `${r.toUpperCase()}-FINISH`)
  ];
}
function Uo(r, t, n) {
  const o = Nt(r, t, n, Bo);
  return [
    X(o, r.toUpperCase())
    //
  ];
}
function Ko(r, t, n) {
  const o = Nt(r, t, n, {
    noCapsMesh: at.create(k / 100, y / 100),
    leftCapMesh: rt.create(k / 100, y / 100),
    rightCapMesh: ct.create(k / 100, y / 100),
    bothCapsMesh: ot.create(k / 100, y / 100)
  }), i = Nt(r, t, n, {
    noCapsMesh: it.create(k / 100, y / 100),
    leftCapMesh: nt.create(k / 100, y / 100),
    rightCapMesh: st.create(k / 100, y / 100),
    bothCapsMesh: tt.create(k / 100, y / 100)
  });
  return [
    X(o, r.toUpperCase()),
    //
    X(i, `${r.toUpperCase()}-FINISH`)
  ];
}
function po(r, t, n, o) {
  const i = n.parts;
  return {
    [z.PP]: {
      [g.FRONT]: () => o.bothCapsMesh(
        t.width / 100,
        //
        n.height / 100,
        t.depth / 100,
        i.left.depth / 100,
        i.right.depth / 100,
        n.bedding / 100
      ),
      [g.BACK]: () => o.bothCapsMesh(
        t.width / 100,
        //
        n.height / 100,
        t.depth / 100,
        i.right.depth / 100,
        i.left.depth / 100,
        n.bedding / 100
      ),
      [g.LEFT]: () => o.noCapsMesh(
        t.width / 100,
        //
        n.height / 100,
        t.depth / 100,
        n.bedding / 100
      ),
      [g.RIGHT]: () => o.noCapsMesh(
        t.width / 100,
        //
        n.height / 100,
        t.depth / 100,
        n.bedding / 100
      )
    },
    [z.PC]: {
      [g.FRONT]: () => o.bothCapsMesh(
        t.width / 100,
        //
        n.height / 100,
        t.depth / 100,
        i.left.depth / 100,
        i.right.depth / 100,
        n.bedding / 100
      ),
      [g.BACK]: () => o.noCapsMesh(
        t.width / 100,
        //
        n.height / 100,
        t.depth / 100,
        n.bedding / 100
      ),
      [g.LEFT]: () => o.leftCapMesh(
        t.width / 100,
        //
        n.height / 100,
        t.depth / 100,
        i.back.depth / 100,
        n.bedding / 100
      ),
      [g.RIGHT]: () => o.rightCapMesh(
        t.width / 100,
        //
        n.height / 100,
        t.depth / 100,
        i.back.depth / 100,
        n.bedding / 100
      )
    },
    [z.CP]: {
      [g.FRONT]: () => o.noCapsMesh(
        t.width / 100,
        //
        n.height / 100,
        t.depth / 100,
        n.bedding / 100
      ),
      [g.BACK]: () => o.bothCapsMesh(
        t.width / 100,
        //
        n.height / 100,
        t.depth / 100,
        i.right.depth / 100,
        i.left.depth / 100,
        n.bedding / 100
      ),
      [g.LEFT]: () => o.rightCapMesh(
        t.width / 100,
        //
        n.height / 100,
        t.depth / 100,
        i.front.depth / 100,
        n.bedding / 100
      ),
      [g.RIGHT]: () => o.leftCapMesh(
        t.width / 100,
        //
        n.height / 100,
        t.depth / 100,
        i.front.depth / 100,
        n.bedding / 100
      )
    },
    [z.CC]: {
      [g.FRONT]: () => o.noCapsMesh(
        t.width / 100,
        //
        n.height / 100,
        t.depth / 100,
        n.bedding / 100
      ),
      [g.BACK]: () => o.noCapsMesh(
        t.width / 100,
        //
        n.height / 100,
        t.depth / 100,
        n.bedding / 100
      ),
      [g.LEFT]: () => o.bothCapsMesh(
        t.width / 100,
        //
        n.height / 100,
        t.depth / 100,
        i.back.depth / 100,
        i.front.depth / 100,
        n.bedding / 100
      ),
      [g.RIGHT]: () => o.bothCapsMesh(
        t.width / 100,
        //
        n.height / 100,
        t.depth / 100,
        i.front.depth / 100,
        i.back.depth / 100,
        n.bedding / 100
      )
    }
  }[n.assemblyType][r]();
}
function Nt(r, t, n, o) {
  const i = n.parts;
  return {
    [z.PP]: {
      [g.FRONT]: () => o.bothCapsMesh(
        t.width / 100,
        //
        n.height[0] / 100,
        n.height[1] / 100,
        t.depth / 100,
        i.left.depth / 100,
        i.right.depth / 100,
        n.bedding / 100
      ),
      [g.BACK]: () => o.bothCapsMesh(
        t.width / 100,
        //
        n.height[0] / 100,
        n.height[1] / 100,
        t.depth / 100,
        i.right.depth / 100,
        i.left.depth / 100,
        n.bedding / 100
      ),
      [g.LEFT]: () => o.noCapsMesh(
        t.width / 100,
        //
        n.height[0] / 100,
        n.height[1] / 100,
        t.depth / 100,
        n.bedding / 100
      ),
      [g.RIGHT]: () => o.noCapsMesh(
        t.width / 100,
        //
        n.height[0] / 100,
        n.height[1] / 100,
        t.depth / 100,
        n.bedding / 100
      )
    },
    [z.PC]: {
      [g.FRONT]: () => o.bothCapsMesh(
        t.width / 100,
        //
        n.height[0] / 100,
        n.height[1] / 100,
        t.depth / 100,
        i.left.depth / 100,
        i.right.depth / 100,
        n.bedding / 100
      ),
      [g.BACK]: () => o.noCapsMesh(
        t.width / 100,
        //
        n.height[0] / 100,
        n.height[1] / 100,
        t.depth / 100,
        n.bedding / 100
      ),
      [g.LEFT]: () => o.leftCapMesh(
        t.width / 100,
        //
        n.height[0] / 100,
        n.height[1] / 100,
        t.depth / 100,
        i.back.depth / 100,
        n.bedding / 100
      ),
      [g.RIGHT]: () => o.rightCapMesh(
        t.width / 100,
        //
        n.height[0] / 100,
        n.height[1] / 100,
        t.depth / 100,
        i.back.depth / 100,
        n.bedding / 100
      )
    },
    [z.CP]: {
      [g.FRONT]: () => o.noCapsMesh(
        t.width / 100,
        //
        n.height[0] / 100,
        n.height[1] / 100,
        t.depth / 100,
        n.bedding / 100
      ),
      [g.BACK]: () => o.bothCapsMesh(
        t.width / 100,
        //
        n.height[0] / 100,
        n.height[1] / 100,
        t.depth / 100,
        i.right.depth / 100,
        i.left.depth / 100,
        n.bedding / 100
      ),
      [g.LEFT]: () => o.rightCapMesh(
        t.width / 100,
        //
        n.height[0] / 100,
        n.height[1] / 100,
        t.depth / 100,
        i.front.depth / 100,
        n.bedding / 100
      ),
      [g.RIGHT]: () => o.leftCapMesh(
        t.width / 100,
        //
        n.height[0] / 100,
        n.height[1] / 100,
        t.depth / 100,
        i.front.depth / 100,
        n.bedding / 100
      )
    },
    [z.CC]: {
      [g.FRONT]: () => o.noCapsMesh(
        t.width / 100,
        //
        n.height[0] / 100,
        n.height[1] / 100,
        t.depth / 100,
        n.bedding / 100
      ),
      [g.BACK]: () => o.noCapsMesh(
        t.width / 100,
        //
        n.height[0] / 100,
        n.height[1] / 100,
        t.depth / 100,
        n.bedding / 100
      ),
      [g.LEFT]: () => o.bothCapsMesh(
        t.width / 100,
        //
        n.height[0] / 100,
        n.height[1] / 100,
        t.depth / 100,
        i.back.depth / 100,
        i.front.depth / 100,
        n.bedding / 100
      ),
      [g.RIGHT]: () => o.bothCapsMesh(
        t.width / 100,
        //
        n.height[0] / 100,
        n.height[1] / 100,
        t.depth / 100,
        i.front.depth / 100,
        i.back.depth / 100,
        n.bedding / 100
      )
    }
  }[n.assemblyType][r]();
}
function wo(r, t, n) {
  const o = n.overall.width / 100 / 2, i = bo(n) / 2, e = n.overall.depth / 100 / 2, a = t.depth / 100 / 2, c = Oo(n), p = ho(n), f = n.parts;
  return {
    [z.PP]: {
      [g.FRONT]: [
        0,
        //
        i,
        e - a
      ],
      [g.BACK]: [
        0,
        //
        i,
        -e + a
      ],
      [g.LEFT]: [
        -o + a,
        //
        i,
        c
      ],
      [g.RIGHT]: [
        o - a,
        //
        i,
        c
      ]
    },
    [z.PC]: {
      [g.FRONT]: [
        0,
        //
        i,
        e - a
      ],
      [g.BACK]: [
        -p,
        //
        i,
        -e + a
      ],
      [g.LEFT]: [
        -o + a,
        //
        i,
        -f.front.depth / 100 / 2
      ],
      [g.RIGHT]: [
        0 + o - a,
        //
        i,
        -f.front.depth / 100 / 2
      ]
    },
    [z.CP]: {
      [g.FRONT]: [
        -p,
        //
        i,
        e - a
      ],
      [g.BACK]: [
        0,
        //
        i,
        -e + a
      ],
      [g.LEFT]: [
        -o + a,
        //
        i,
        f.back.depth / 100 / 2
      ],
      [g.RIGHT]: [
        0 + o - a,
        //
        i,
        f.back.depth / 100 / 2
      ]
    },
    [z.CC]: {
      [g.FRONT]: [
        -p,
        //
        i,
        e - a
      ],
      [g.BACK]: [
        -p,
        //
        i,
        -e + a
      ],
      [g.LEFT]: [
        -o + a,
        //
        i,
        0
      ],
      [g.RIGHT]: [
        o - a,
        //
        i,
        0
      ]
    }
  }[n.assemblyType][r];
}
function Yo(r) {
  switch (r) {
    case g.FRONT:
      return [0, 0, 0];
    case g.BACK:
      return [0, 180, 0];
    case g.LEFT:
      return [0, -90, 0];
    case g.RIGHT:
      return [0, 90, 0];
    default:
      return [0, 0, 0];
  }
}
export {
  z as AssemblyType,
  N as Face,
  Ro as FovType,
  H as HRAabb3,
  g as PartId,
  uo as WRAPIv2,
  Qo as aabbFacePointOfView,
  $o as aabbPointOfView,
  Wo as placageAssemblyAabb,
  Po as placageAssemblyHeight,
  Xo as placageAssemblyScene,
  Lo as placageHeight,
  Zo as semelleAssemblyAabb,
  Oo as semelleAssemblyFrontViewOffset,
  bo as semelleAssemblyHeight,
  ho as semelleAssemblyLeftViewOffset,
  Ao as semelleAssemblyScene
};
